import React, { Component, Fragment } from "react";
import "./WhatsApp.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { 
    APPLICATION_NAME, 
    DOC, 
    DOCX, 
    PDF, 
    DOCUMENT, 
    JPG, 
    PNG, 
    TEXT, 
    XLS, 
    IMAGE, 
    AUDIO, 
    days
} from "../../core/constants";
import {
    fomartedCellphone,
    getWindowDimensions,
    formatedDateTimeToUSA,
    getDateTimeCurrentBrowserUSA, 
    formatedDateTimeToBrowserAtAnyTime,
    getDateTimeCurrentBrowserAtMidnight,
    getPreviousDateTimeCurrentBrowserAtMidnight,
    isEmpty, 
} from "../../auxiliary/generalFunctions";
import { setModalMessage, setListenerWhatsAppUpdatedMessages } from "../../store/actions/general";

import ItemListWhatsApp from "../../components/CRM/ItemListWhatsApp";
import DropdownWhatsApp from "../../components/CRM/DropdownWhatsApp";
import ButtonWhatsApp from "../../components/CRM/ButtonWhatsApp";
import NoOpenedChatWhatsApp from "../../components/CRM/NoOpenedChatWhatsApp";
import MessageTextWhatsApp from "../../components/CRM/MessageTextWhatsApp";
import MessageDocumentWhatsApp from "../../components/CRM/MessageDocumentWhatsApp";
import MessageImageWhatsApp from "../../components/CRM/MessageImageWhatsApp";
import MessageAudioWhatsApp from "../../components/CRM/MessageAudioWhatsApp";
import AudioRecordingWhatsApp from "../../components/CRM/AudioRecordingWhatsApp";
import ButtonDetailsAndSelectPanelWhatsApp from "../../components/CRM/ButtonDetailsAndSelectPanelWhatsApp";
import Select from "../../components/general/Select";

import WhatsAppController from "../../controllers/WhatsAppController";
import MessageConfirmation from "../../components/general/MessageConfirmation";
import UserController from "../../controllers/UserController";
import axios from "axios";
import Check from "../../components/general/Check";
import ButtonIcon from "../../components/general/ButtonIcon";
import MessageContent from "../../components/general/MessageContent";
import Button from "../../components/general/Button";
import WhatsAppButtonQuickMessage from "./WhatsAppButtonQuickMessage";
import InputGeneral from "../../components/general/InputGeneral";

const WIDTH_MENUS_CRM = 56; //default is 56][px]
const WIDTH_CHAT_LIST = 430; //default is 430[px]
const WIDTH_MORE_DETAILS_PROFILE = 450; //default is 450[px]
// const AVATAR = ("../../assets/images/user.jpeg");
const ANSWER_MESSAGE_DEFAULT = {id: null, name: "", message: "", type: ""};
const HEIGHT_ITEM_CHAT = 72; //default is 72[px] (vide .itemListWhatsApp)
// const AMOUNT_MESSAGES_BY_CHAT_TO_LOAD = 10; //default is 10
var CONST_MINIMUM_CHATS_TO_LOAD = 1; //default is (one)
var MINIMUM_CHATS_TO_LOAD = 20; //DANGER: this number must be even! default is 8 (for maintenance) or 20 (for production)
var AMOUNT_SCROLLED_CHAT_LIST = 0; //default is (zero)

// WARNING: don't remove the follow constant:
// const CHATS_BY_CONTACT_CHAT = [
//     {
//         idContact: 1,
//         nameContact: "Bruna M.",
//         cellphoneContact: "+55 11 1234-5678",
//         nicknameContact: "~bruna",
//         photoContact: AVATAR,
//         verifiedContact: false,
//         isChatFromMe: true,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//         messages: [],
//     },
//     {
//         idContact: 2,
//         nameContact: "Maria das Dores",
//         cellphoneContact: "+55 11 2345-6789",
//         nicknameContact: "~maria",
//         photoContact: "https://img.freepik.com/fotos-gratis/mulher-tirando-foto-do-mar-de-costas_23-2148739297.jpg?w=2000",
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//         messages: []
//     },
//     {
//         idContact: 3,
//         nameContact: "Capitão Bolsonaro",
//         cellphoneContact: "+55 21 3456-7891",
//         nicknameContact: "~capitão",
//         photoContact: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 4,
//         nameContact: "Antonio Cruz Credo",
//         cellphoneContact: "+55 31 4567-8912",
//         nicknameContact: "~antonio",
//         photoContact: "data:image/jpeg;base64,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",
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 5,
//         nameContact: "Padre dos Milagres do Céu",
//         cellphoneContact: "+55 11 5678-9123",
//         nicknameContact: "~padre",
//         photoContact: "data:image/jpeg;base64,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",
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 6,
//         nameContact: "Nubank",
//         cellphoneContact: "+55 11 6789-1234",
//         nicknameContact: "~nubank",
//         photoContact: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/nubank.jpeg",
//         verifiedContact: true,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 7,
//         nameContact: "Bruxa do 71",
//         cellphoneContact: "+55 66 6666-6666",
//         nicknameContact: "~bruxa",
//         photoContact: "https://s2.glbimg.com/ePKGmXEpW4G4iXpZJOl7UaB94ky3x6hg9A6cNSzhyatIoz-HdGixxa_8qOZvMp3w/e.glbimg.com/og/ed/f/original/2014/03/26/donaclotilde.jpg",
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 8,
//         nameContact: "Bob's esponja",
//         cellphoneContact: "+55 11 7891-2345",
//         nicknameContact: "~bobs",
//         photoContact: "data:image/jpeg;base64,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",
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 9,
//         nameContact: "Cebolinha",
//         cellphoneContact: "+55 11 8912-3456",
//         nicknameContact: "~cebolinha",
//         photoContact: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/cebolinha.jpeg",
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 10,
//         nameContact: "Interstellar",
//         cellphoneContact: "+55 11 9123-4567",
//         nicknameContact: "~interstellar",
//         photoContact: "data:image/jpeg;base64,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",
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 11,
//         nameContact: "+1 123-4567",
//         cellphoneContact: "+1 123-4567",
//         nicknameContact: "~camila",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 12,
//         nameContact: "+12",
//         cellphoneContact: "+12",
//         nicknameContact: "~12",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 13,
//         nameContact: "+13",
//         cellphoneContact: "+13",
//         nicknameContact: "~13",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 14,
//         nameContact: "+14",
//         cellphoneContact: "+14",
//         nicknameContact: "~14",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 15,
//         nameContact: "+15",
//         cellphoneContact: "+15",
//         nicknameContact: "~15",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 16,
//         nameContact: "+16",
//         cellphoneContact: "+16",
//         nicknameContact: "~16",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 17,
//         nameContact: "+17",
//         cellphoneContact: "+17",
//         nicknameContact: "~17",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 18,
//         nameContact: "+18",
//         cellphoneContact: "+18",
//         nicknameContact: "~18",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 19,
//         nameContact: "+19",
//         cellphoneContact: "+19",
//         nicknameContact: "~19",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 20,
//         nameContact: "+20",
//         cellphoneContact: "+20",
//         nicknameContact: "~20",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 21,
//         nameContact: "+21",
//         cellphoneContact: "+21",
//         nicknameContact: "~21",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 22,
//         nameContact: "+22",
//         cellphoneContact: "+22",
//         nicknameContact: "~22",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 23,
//         nameContact: "+23",
//         cellphoneContact: "+23",
//         nicknameContact: "~23",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 24,
//         nameContact: "+24",
//         cellphoneContact: "+24",
//         nicknameContact: "~24",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 25,
//         nameContact: "+25",
//         cellphoneContact: "+25",
//         nicknameContact: "~25",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 26,
//         nameContact: "+26",
//         cellphoneContact: "+26",
//         nicknameContact: "~26",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 27,
//         nameContact: "+27",
//         cellphoneContact: "+27",
//         nicknameContact: "~27",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 28,
//         nameContact: "+28",
//         cellphoneContact: "+28",
//         nicknameContact: "~28",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 29,
//         nameContact: "+29",
//         cellphoneContact: "+29",
//         nicknameContact: "~29",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 30,
//         nameContact: "+30",
//         cellphoneContact: "+30",
//         nicknameContact: "~30",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 31,
//         nameContact: "+31",
//         cellphoneContact: "+31",
//         nicknameContact: "~31",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 32,
//         nameContact: "+32",
//         cellphoneContact: "+32",
//         nicknameContact: "~32",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 33,
//         nameContact: "+33",
//         cellphoneContact: "+33",
//         nicknameContact: "~33",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 34,
//         nameContact: "+34",
//         cellphoneContact: "+34",
//         nicknameContact: "~34",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 35,
//         nameContact: "+35",
//         cellphoneContact: "+35",
//         nicknameContact: "~35",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 36,
//         nameContact: "+36",
//         cellphoneContact: "+36",
//         nicknameContact: "~36",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 37,
//         nameContact: "+37",
//         cellphoneContact: "+37",
//         nicknameContact: "~37",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 38,
//         nameContact: "+38",
//         cellphoneContact: "+38",
//         nicknameContact: "~38",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 39,
//         nameContact: "+39",
//         cellphoneContact: "+39",
//         nicknameContact: "~39",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 40,
//         nameContact: "+40",
//         cellphoneContact: "+40",
//         nicknameContact: "~40",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 41,
//         nameContact: "+41",
//         cellphoneContact: "+41",
//         nicknameContact: "~41",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 42,
//         nameContact: "+42",
//         cellphoneContact: "+42",
//         nicknameContact: "~42",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 43,
//         nameContact: "+43",
//         cellphoneContact: "+43",
//         nicknameContact: "~43",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 44,
//         nameContact: "+44",
//         cellphoneContact: "+44",
//         nicknameContact: "~44",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 45,
//         nameContact: "+45",
//         cellphoneContact: "+45",
//         nicknameContact: "~45",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 46,
//         nameContact: "+46",
//         cellphoneContact: "+46",
//         nicknameContact: "~46",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 47,
//         nameContact: "+47",
//         cellphoneContact: "+47",
//         nicknameContact: "~47",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 48,
//         nameContact: "+48",
//         cellphoneContact: "+48",
//         nicknameContact: "~48",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 49,
//         nameContact: "+49",
//         cellphoneContact: "+49",
//         nicknameContact: "~49",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 50,
//         nameContact: "+50",
//         cellphoneContact: "+50",
//         nicknameContact: "~50",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 51,
//         nameContact: "+51",
//         cellphoneContact: "+51",
//         nicknameContact: "~51",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 52,
//         nameContact: "+52",
//         cellphoneContact: "+52",
//         nicknameContact: "~52",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 53,
//         nameContact: "+53",
//         cellphoneContact: "+53",
//         nicknameContact: "~53",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 54,
//         nameContact: "+54",
//         cellphoneContact: "+54",
//         nicknameContact: "~54",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 55,
//         nameContact: "+55",
//         cellphoneContact: "+55",
//         nicknameContact: "~55",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 56,
//         nameContact: "+56",
//         cellphoneContact: "+56",
//         nicknameContact: "~56",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 57,
//         nameContact: "+57",
//         cellphoneContact: "+57",
//         nicknameContact: "~57",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 58,
//         nameContact: "+58",
//         cellphoneContact: "+58",
//         nicknameContact: "~58",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 59,
//         nameContact: "+59",
//         cellphoneContact: "+59",
//         nicknameContact: "~59",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 60,
//         nameContact: "+60",
//         cellphoneContact: "+60",
//         nicknameContact: "~60",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 61,
//         nameContact: "+61",
//         cellphoneContact: "+61",
//         nicknameContact: "~61",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 62,
//         nameContact: "+62",
//         cellphoneContact: "+62",
//         nicknameContact: "~62",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 63,
//         nameContact: "+63",
//         cellphoneContact: "+63",
//         nicknameContact: "~63",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 64,
//         nameContact: "+64",
//         cellphoneContact: "+64",
//         nicknameContact: "~64",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 65,
//         nameContact: "+65",
//         cellphoneContact: "+65",
//         nicknameContact: "~65",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 66,
//         nameContact: "+66",
//         cellphoneContact: "+66",
//         nicknameContact: "~66",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 67,
//         nameContact: "+67",
//         cellphoneContact: "+67",
//         nicknameContact: "~67",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 68,
//         nameContact: "+68",
//         cellphoneContact: "+68",
//         nicknameContact: "~68",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 69,
//         nameContact: "+69",
//         cellphoneContact: "+69",
//         nicknameContact: "~69",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 70,
//         nameContact: "+70",
//         cellphoneContact: "+70",
//         nicknameContact: "~70",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 71,
//         nameContact: "+71",
//         cellphoneContact: "+71",
//         nicknameContact: "~71",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 72,
//         nameContact: "+72",
//         cellphoneContact: "+72",
//         nicknameContact: "~72",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 73,
//         nameContact: "+73",
//         cellphoneContact: "+73",
//         nicknameContact: "~73",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
//     {
//         idContact: 74,
//         nameContact: "+74",
//         cellphoneContact: "+74",
//         nicknameContact: "~74",
//         photoContact: null,
//         verifiedContact: false,
//         isChatFromMe: false,
//         amountMessagesLoaded: AMOUNT_MESSAGES_BY_CHAT_TO_LOAD,
//     },
// ]
// const MESSAGES_BY_CONTACT_CHAT = [
//     {
//         id: 1,
//         idContact: 1,
//         type: TEXT,
//         message: "https://play.google.com/apps/internaltest/4700961696314586759",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 2,
//         idContact: 1,
//         type: TEXT,
//         message: "🎉 Parabéns Bruna, quero te desejar muitas felicidades, saúde e conquistas pra ti. Aproveite bem por aí tah? 😍",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 3,
//         idContact: 1,
//         type: TEXT,
//         message: "Sim",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 4,
//         idContact: 1,
//         type: TEXT,
//         message: "kkkkk",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 5,
//         idContact: 1,
//         type: TEXT,
//         message: "não brinca",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: true,
//         emphasis: false
//     },
//     {
//         id: 6,
//         idContact: 1,
//         type: TEXT,
//         message: "não brinca, não",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 7,
//         idContact: 1,
//         type: TEXT,
//         message: "https://play.google.com/apps/internaltest/4700961696314586759",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 8,
//         idContact: 1,
//         type: TEXT,
//         message: "🎉 Parabéns Bruna, quero te desejar muitas felicidades, saúde e conquistas pra ti. Aproveite bem por aí tah? 😍",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 9,
//         idContact: 1,
//         type: TEXT,
//         message: "Sim",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 10,
//         idContact: 1,
//         type: TEXT,
//         message: "kkkkk",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 11,
//         idContact: 1,
//         type: TEXT,
//         message: "https://play.google.com/apps/internaltest/4700961696314586759",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: true,
//         emphasis: false
//     },
//     {
//         id: 12,
//         idContact: 1,
//         type: TEXT,
//         message: "fechou",
//         datetime: "2023-07-17 09:44:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 13,
//         idContact: 2,
//         type: TEXT,
//         message: "pq?",
//         datetime: "2023-07-01 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: true,
//         emphasis: false
//     },
//     {
//         id: 14,
//         idContact: 3,
//         type: TEXT,
//         message: "msg 1",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 15,
//         idContact: 3,
//         type: TEXT,
//         message: "msg 2",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 14,
//             name: "Você",
//             message: "msg 1"
//         }
//     },
//     {
//         id: 16,
//         idContact: 3,
//         type: TEXT,
//         message: "msg 3",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 15,
//             name: "Você",
//             message: "msg 2"
//         }
//     },
//     {
//         id: 17,
//         idContact: 3,
//         type: TEXT,
//         message: "msg 1",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 18,
//         idContact: 3,
//         type: TEXT,
//         message: "msg 2",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 17,
//             name: "Capitão Bolsonaro",
//             message: "msg 1"
//         }
//     },
//     {
//         id: 19,
//         idContact: 3,
//         type: TEXT,
//         message: "msg 3",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 18,
//             name: "Capitão Bolsonaro",
//             message: "msg 2"
//         }
//     },
//     {
//         id: 20,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Gastos.xls",
//             pages: 2,
//             extension: XLS,
//             size: "16 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.xls"
//         }
//     },
//     {
//         id: 21,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Análise financeira.pdf",
//             pages: 2,
//             extension: PDF,
//             size: "50 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.pdf"
//         }
//     },
//     {
//         id: 22,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Redação.doc",
//             pages: 2,
//             extension: DOC,
//             size: "150 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.doc"
//         }
//     },
//     {
//         id: 23,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Arquivo.kkz",
//             pages: 2,
//             extension: "KKZ",
//             size: "150 KB",
//             path: ""
//         }
//     },
//     {
//         id: 24,
//         idContact: 3,
//         type: TEXT,
//         message: "vou enviar os gastos novamente!",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//     },
//     {
//         id: 25,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 24,
//             name: "Você",
//             message: "vou enviar os gastos novamente!"
//         },
//         file: {
//             name: "Gastos 2.xls",
//             pages: 2,
//             extension: XLS,
//             size: "16 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.xls"
//         }
//     },
//     {
//         id: 26,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "message de documento, com uma referência ativa e uma mensagem nova",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 24,
//             name: "Você",
//             message: "vou enviar os gastos novamente!"
//         },
//         file: {
//             name: "Gastos 3.xls",
//             pages: 2,
//             extension: XLS,
//             size: "16 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.xls"
//         }
//     },
//     {
//         id: 27,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "message de documento, com uma referência ativa a uma mensagem de documento e uma mensagem nova.",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 26,
//             name: "Você",
//             message: "message de documento, com uma referência ativa e uma mensagem nova!",
//             type: DOCUMENT
//         },
//         file: {
//             name: "Gastos 3.xls",
//             pages: 2,
//             extension: XLS,
//             size: "16 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.xls"
//         }
//     },
//     {
//         id: 28,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Gastos.xls",
//             pages: 2,
//             extension: XLS,
//             size: "16 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.xls"
//         }
//     },
//     {
//         id: 29,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Análise financeira.pdf",
//             pages: 2,
//             extension: PDF,
//             size: "50 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.pdf"
//         }
//     },
//     {
//         id: 30,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Redação.doc",
//             pages: 2,
//             extension: DOC,
//             size: "150 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.doc"
//         }
//     },
//     {
//         id: 31,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Arquivo.kkz",
//             pages: 2,
//             extension: "KKZ",
//             size: "150 KB",
//             path: ""
//         }
//     },
//     {
//         id: 32,
//         idContact: 3,
//         type: TEXT,
//         message: "vou enviar os gastos novamente!",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//     },
//     {
//         id: 33,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 32,
//             name: "Capitão Bolsonaro",
//             message: "vou enviar os gastos novamente!"
//         },
//         file: {
//             name: "Gastos 2.xls",
//             pages: 2,
//             extension: XLS,
//             size: "16 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.xls"
//         }
//     },
//     {
//         id: 34,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "message de documento, com uma referência ativa e uma mensagem nova",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 32,
//             name: "Capitão Bolsonaro",
//             message: "vou enviar os gastos novamente!"
//         },
//         file: {
//             name: "Gastos 3.xls",
//             pages: 2,
//             extension: XLS,
//             size: "16 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.xls"
//         }
//     },
//     {
//         id: 35,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "message de documento, com uma referência ativa a uma mensagem de documento e uma mensagem nova.",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         answer: {
//             id: 34,
//             name: "Capitão Bolsonaro",
//             message: "message de documento, com uma referência ativa e uma mensagem nova!",
//             type: DOCUMENT
//         },
//         file: {
//             name: "Gastos 3.xls",
//             pages: 2,
//             extension: XLS,
//             size: "16 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.xls"
//         }
//     },
//     {
//         id: 36,
//         idContact: 3,
//         type: TEXT,
//         message: "envia a imagem pfv",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//     },
//     {
//         id: 37,
//         idContact: 3,
//         type: IMAGE,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 38,
//         idContact: 3,
//         type: IMAGE,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//         answer: {
//             id: 36,
//             name: "Você",
//             message: "envia a imagem pfv"
//         },
//     },
//     {
//         id: 39,
//         idContact: 3,
//         type: IMAGE,
//         message: "aqui está a imagem em resposta a uma msg de texto.",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//         answer: {
//             id: 36,
//             name: "Você",
//             message: "envia a imagem pfv"
//         },
//     },
//     {
//         id: 40,
//         idContact: 3,
//         type: IMAGE,
//         message: "mensagem de imagem, com texto em resposta a uma mensagem completa do tipo imagem (resposta, imagem e texto).",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//         answer: {
//             id: 39,
//             name: "Você",
//             message: "aqui está a imagem em resposta a uma msg de texto.",
//             type: IMAGE,
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 41,
//         idContact: 3,
//         type: TEXT,
//         message: "envia a imagem pfv",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//     },
//     {
//         id: 42,
//         idContact: 3,
//         type: IMAGE,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 43,
//         idContact: 3,
//         type: IMAGE,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//         answer: {
//             id: 41,
//             name: "Capitão Bolsonaro",
//             message: "envia a imagem pfv"
//         },
//     },
//     {
//         id: 44,
//         idContact: 3,
//         type: IMAGE,
//         message: "aqui está a imagem em resposta a uma msg de texto.",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//         answer: {
//             id: 41,
//             name: "Capitão Bolsonaro",
//             message: "envia a imagem pfv"
//         },
//     },
//     {
//         id: 45,
//         idContact: 3,
//         type: IMAGE,
//         message: "mensagem de imagem, com texto em resposta a uma mensagem completa do tipo imagem (resposta, imagem e texto).",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//         answer: {
//             id: 44,
//             name: "Capitão Bolsonaro",
//             message: "aqui está a imagem em resposta a uma msg de texto.",
//             type: IMAGE,
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 46,
//         idContact: 3,
//         type: TEXT,
//         message: "explica por áudios por favor...",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 47,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         statusAudio: 2,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/celestial.mp3"
//         },
//     },
//     {
//         id: 48,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/celestial.mp3"
//         },
//         answer: {
//             id: 46,
//             name: "Você",
//             message: "explica por áudios por favor...",
//         },
//     },
//     {
//         id: 49,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/era.mp3"
//         },
//         answer: {
//             id: 48,
//             name: "Você",
//             message: "0:00",
//             type: AUDIO,
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/celestial.mp3"
//         },
//     },
//     {
//         id: 50,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "documento com mensagem",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Análise financeira.pdf",
//             pages: 2,
//             extension: PDF,
//             size: "50 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.pdf"
//         }
//     },
//     {
//         id: 51,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/beethoven.mp3"
//         },
//         answer: {
//             id: 50,
//             name: "Você",
//             message: "documento com mensagem",
//             type: DOCUMENT,
//         },
//     },
//     {
//         id: 52,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Análise financeira.pdf",
//             pages: 2,
//             extension: PDF,
//             size: "50 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.pdf"
//         }
//     },
//     {
//         id: 53,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/beethoven.mp3"
//         },
//         answer: {
//             id: 52,
//             name: "Você",
//             message: "Análise financeira.pdf",
//             type: DOCUMENT,
//         },
//     },
//     {
//         id: 54,
//         idContact: 3,
//         type: IMAGE,
//         message: "foto com msg",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 55,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/beethoven.mp3"
//         },
//         answer: {
//             id: 54,
//             name: "Você",
//             message: "foto com msg",
//             type: IMAGE,
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 56,
//         idContact: 3,
//         type: IMAGE,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 57,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: true,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/beethoven.mp3"
//         },
//         answer: {
//             id: 56,
//             name: "Você",
//             message: "Foto",
//             type: IMAGE,
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 58,
//         idContact: 3,
//         type: TEXT,
//         message: "explica por áudios por favor...",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false
//     },
//     {
//         id: 59,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         statusAudio: 2,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/celestial.mp3"
//         },
//     },
//     {
//         id: 60,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/celestial.mp3"
//         },
//         answer: {
//             id: 58,
//             name: "Capitão Bolsonaro",
//             message: "explica por áudios por favor...",
//         },
//     },
//     {
//         id: 61,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/era.mp3"
//         },
//         answer: {
//             id: 59,
//             name: "Capitão Bolsonaro",
//             message: "0:00",
//             type: AUDIO,
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/celestial.mp3"
//         },
//     },
//     {
//         id: 62,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "documento com mensagem",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Análise financeira.pdf",
//             pages: 2,
//             extension: PDF,
//             size: "50 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.pdf"
//         }
//     },
//     {
//         id: 63,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/beethoven.mp3"
//         },
//         answer: {
//             id: 62,
//             name: "Capitão Bolsonaro",
//             message: "documento com mensagem",
//             type: DOCUMENT,
//         },
//     },
//     {
//         id: 64,
//         idContact: 3,
//         type: DOCUMENT,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Análise financeira.pdf",
//             pages: 2,
//             extension: PDF,
//             size: "50 KB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/documents/2023-08-22/document.pdf"
//         }
//     },
//     {
//         id: 65,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/beethoven.mp3"
//         },
//         answer: {
//             id: 64,
//             name: "Capitão Bolsonaro",
//             message: "Análise financeira.pdf",
//             type: DOCUMENT,
//         },
//     },
//     {
//         id: 66,
//         idContact: 3,
//         type: IMAGE,
//         message: "foto com msg",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 67,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/beethoven.mp3"
//         },
//         answer: {
//             id: 66,
//             name: "Capitão Bolsonaro",
//             message: "foto com msg",
//             type: IMAGE,
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 68,
//         idContact: 3,
//         type: IMAGE,
//         message: "",
//         datetime: "2023-07-17 09:45:00",
//         sentForMe: false,
//         status: 3,
//         isDeleted: false,
//         emphasis: false,
//         file: {
//             name: "Desert.jpeg",
//             pages: 0,
//             extension: JPG,
//             size: "1,4 MB",
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
//     {
//         id: 69,
//         idContact: 3,
//         type: AUDIO,
//         datetime: "2023-11-14 09:45:00",
//         sentForMe: false,
//         status: 3,
//         statusAudio: 1,
//         isDeleted: false,
//         emphasis: false,
//         focused: false,
//         playing: false,
//         avatarNoMe: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_AHa8u96nC5_poAE110IhazPb97_dgMFJeA&usqp=CAU",
//         file: {
//             path: "",
//             download: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/audios/2023-08-22/beethoven.mp3"
//         },
//         answer: {
//             id: 68,
//             name: "Capitão Bolsonaro",
//             message: "Foto",
//             type: IMAGE,
//             path: "https://crm-backend.epic-rubin.207-38-89-189.plesk.page/uploads/whatsapp/images/2023-08-22/desert.jpeg"
//         },
//     },
// ];
const OBJ_MESSAGE_TARGET_BY_DROPDOWN_ACTIONS = {id: null, message: ""} //default is {id: null, message: ""}
const CLOSED_CHAT = {
    openedChat: false, //default is false
    idOpenedChat: null, //default is null
    indexOpenedChat: null, //default is null
    idLastCalledOpenedChat: null, //default is null
    nameContactChat: "", //default is empty string
    cellphoneContactChat: "", //default is empty string
    photoContactChat: null, //default is null,
    timeContactChat: "", //default is empty string
    openedProfileChat: false, //default is empty string
    nameConnection: "", //default is empty string
    messagesByChatComponents: [], //default is empty array,
    statusCalled: 2, //default is 2 (two)
    idDepartament: "", //default is empty string
    idCalled: "", //default is empty string
    idServiceDigiSac: "", //default is empty string
    cellphoneNumberClient: "", //default is empty string example "551195998808" (Just from client, not phone from connection api)
    idUserCRMFromCalled: null, //default is null
    nameUserCRMFromCalled: null, //default is null
    infosCalled: {}, //default is empty object
    transferingCalled: false, //default is false
    choosenDepartament: null, //default is null

    // start message confirmation modal
    message_type_confirmation: "information",
    message_show_confirmation: false,
    message_confirmation: "",
    statusConfirmation: false,
    nameFunctionYesModalConfirmation: "",
    objectConfirmation: {},
    numberTargetElementToConfirmation: 0, //default is zero
    // ends message confirmation modal
};
const CLOSED_UPLOAD_FILE_CHAT = {
    uploadModeChat: false, //default is false
    nameFileUploadChat: "", //defaultis empty string
    sizeFileUploadChat: "", //defaultis empty string
    extensionFileUploadChat: "", //defaultis empty string
    messageFileUploadChat: "", //defaultis empty string
    pathFileUploadChat: "", //default is empty string
    fileFileUploadChat: null, //default is null
};
const AUDIO_RECORD = {
    recording: false, //default is false
    clearRecording: true, //default is true
    audioRecord: false, //default is false
    pathAudio: null, //default is false
    blobAudio: null,
};
const INPUT_SENDING = {
    factorHeightInputSending: 1, //default is 1 (one), and maximum 5 (five)
    minHeightInputSending: 42, //default is 42px
    inputSendigShiftLeftPressed: false, //default is false
};
const DEFAULT_PARAMS_MODAL_CONTENT = {
    message_type_content: "information",
    message_show_content: false,
    message_content_content: null, //DOM element
    message_title_content: "",
    message_size_content: "", //default is empty string,
    message_slug_target_content: "", //default is empty string
};
const initialState = {
    valueSearching: "",
    valueSending: "", //for input sending message
    valueTesting: "",
    valueCommentsSending: "", //for input sending comments on modal
    valueCommentsTransferSending: "", //for input sending comments on modal transfer
    valueEditingSending: "", //for input sending message when editing a message
    valueEditNameContact: "", //for input edit name contact
    isCommentSending: false, //default is false
    idMessageEditingSending: "", //default is empty string
    idCalledItemList: null, //default is null
    modeSending: AUDIO, //default is AUDIO
    ...INPUT_SENDING,
    ...AUDIO_RECORD,

    chats: [],
    gettingChats: false, //default is false
    // messagesByChat: [...MESSAGES_BY_CONTACT_CHAT],
    messagesByChat: [],
    chatsFiltered: [],
    searching: false, //default is false
    maintenance: false, //default is false
    pendingScrollToEndMessages: false, //default is false
    pendingScrollToAnswerMessage: false, //default is false
    idMessageToScrollAnswerMessage: null, //default is null
    hasAvatar: false, //default is false

    activeButtonBackChatList: false, //default is false
    activeButtonFilter: false, //default is false
    activeCheckMyOwnCalledsFilter: false, //default is false
    activeCheckClosedCalledsFilter: false, //default is false
    activeButtonMoreOptions: false, //default is false
    activeButtonScrollToBottom: false, //default is false
    activeButtonCopyCellphoneToClipboard: false,
    activeDropdownMoreOptions: false, //default is false
    activeDropdownItemList: false, //default is false
    activeDropdownActionsMessages: false, //default is false
    activeDropdownMoreActionsAttachments: false, //default is false
    activeTimeContactChat: false, //default is false
    activeAnswerMessage: false, //default is false

    styleDropdownItemList: {},
    styleDropdownActionsMessages: {top: 0, right: 0},
    effectDropdownItemList: "activeLeftTop",
    effectDropdownActionsMessage: "activeRightTop",
    showOptionDeleteDropdownActionsMessage: true,
    showOptionsEditingDropdownActionsMessage: true,

    ...CLOSED_CHAT,
    ...CLOSED_UPLOAD_FILE_CHAT,
    messagesByContactChat: [], //default is empty array
    targetMessageMoreActionContactChat: {},
    answerMessage: ANSWER_MESSAGE_DEFAULT,

    widthChatList: 0, //default is 0
    widthConversationPanel: 0, //default is 0
    widthMoreDetailsProfile: 0, //default is 0
    activeMoreDetailsProfileFile: false, //defaul is false

    outputContent: "", //default is empty string (for debugging)
    outputVisible: false, //default is false

    objMessageTargetByDropdownActions: {...OBJ_MESSAGE_TARGET_BY_DROPDOWN_ACTIONS},

    optionsDepartaments: [],
    optionsDepartamentsFiltered: [],
    chosenUserFromDepartament: null,
    optionsUsersFromtDepartaments: [],

    isUserWithMultipleDepartaments: false, //default is false

    activeFilterByParamsURL: false,
    phoneClientParamsURL: "",
    nameClientParamsURL: "",
    idCompanyUnitParamsURL: "",

    showHelpFilterSearching: false,

    initialLoaded: false,

    ...DEFAULT_PARAMS_MODAL_CONTENT
};

const whatsappController = new WhatsAppController();
const userController = new UserController();
class WhatsApp extends Component
{
    state = { ...initialState }

    constructor (props)
    {
        super(props);
        this.chatList = React.createRef();
        this.conversationMessagesPanel = React.createRef();
        this.inputSearching = React.createRef();
        this.inputSending = React.createRef();
        this.inputFile = React.createRef();
        this.buttonMoreOptions = React.createRef();
        this.buttonMoreOptionsAttachments = React.createRef();
        this.dropdownOptionsAttachments = React.createRef();
        this.dropdownItemList = React.createRef();
        this.dropdownActionsMessages = React.createRef();
        this.handleClickOutSide = this.handleClickOutSide.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    componentDidMount = async () =>
    {
        console.log("(2025-06-09 12:00) WhatsApp is ready!");

        document.title = `${APPLICATION_NAME} - WhatsApp`;
        document.addEventListener("mousedown", this.handleClickOutSide);
        document.addEventListener("keydown", this.handleKeyPress);
        this.chatList.current.addEventListener("scroll", this.handleScrollChatList, { passive: true });

        await this.setDimensionsWhatsApp();
        await this.getAvatar();
        await this.checkingParamsURL();
        await this.checkingUserWithMultipleDepartaments();

        // await this.getAllChatsRealtime(); //WARNING: call this method only after you have correctly loaded the permissions.
        // await this.maintenance();
    }

    componentWillUnmount = () =>
    {
        document.removeEventListener("mousedown", this.handleClickOutSide);
        document.removeEventListener("keydown", this.handleKeyPress);
        this.chatList.current.removeEventListener("scroll", this.handleScrollChatList, { passive: true });
    }

    componentDidUpdate = async (prevProps, prevState) =>
    {
        // console.log("WHATSAPP prevProps: ", prevProps.general.listenerWhatsAppUpdatedMessagesActivated);
        // console.log("WHATSAPP this.props: ", this.props.general.listenerWhatsAppUpdatedMessagesActivated);

        if (this.props.general.listenerWhatsAppUpdatedMessagesActivated)
        {
            this.props.setListenerWhatsAppUpdatedMessages(false);
            await this.getAllChatsRealtime();
        }

        if (this.props.hasPermissionsLoaded) 
		{
			if (!this.props.whatsapp.toView) 
			{ this.props.history.push(`/activities`); }

            if (!prevState?.initialLoaded && !this.state.initialLoaded)
            {
                await this.setState({initialLoaded: true}); //DANGER: setting this state here to avoid infinite loop.
                await this.getAllChatsRealtime();
            }
		}
    }

	getAvatar = async () => 
	{
		let result = await userController.hasAvatar(this.props.user.PER_ID);
		if (result.status)
		{
			let {data} = result.data;
			this.setState({hasAvatar: data});
		}
	}

    listenerMessages  = async () =>
    {

    }

    checkingParamsURL = async () =>
    {
        const { path, params } = this.props.match;

        if
        (
            path.includes("whatsapp/") &&
            params.phoneClient !== undefined &&
            params.nameClient !== undefined &&
            params.idCompanyUnit !== undefined
        )
        {
            await this.setState({
                activeFilterByParamsURL: true,
                phoneClientParamsURL: params.phoneClient,
                nameClientParamsURL: params.nameClient,
                idCompanyUnitParamsURL: params.idCompanyUnit
            });
        }
    }

    getAllChatsRealtime = async (cache = false) =>
    {
        console.log("getting chats realtime...");

        await this.setState({gettingChats: true});

        let chats = [];
        let valueSearching = await this.state.valueSearching;
        let oldChats = await this.state.chats;
        let activeFilterByParamsURL = await this.state.activeFilterByParamsURL;
        let activeCheckMyOwnCalledsFilter = await this.state.activeCheckMyOwnCalledsFilter;
        let activeCheckClosedCalledsFilter = await this.state.activeCheckClosedCalledsFilter;
        let amount = (MINIMUM_CHATS_TO_LOAD * CONST_MINIMUM_CHATS_TO_LOAD);

        // @OVERWRITE
        cache = false; //WARNING: exists 2 caches (for bot-webhook and attendant user)

        if (!cache)
        {
            let result = null;
            
            if (activeFilterByParamsURL)
            {
                let phoneClientParamsURL = await this.state.phoneClientParamsURL;
                let nameClientParamsURL = await this.state.nameClientParamsURL;
                let idCompanyUnitParamsURL = await this.state.idCompanyUnitParamsURL;

                let user = this.props.user;
                let fields = {
                    phoneClient: phoneClientParamsURL,
                    nameClient: nameClientParamsURL,
                    idCompanyUnit: idCompanyUnitParamsURL,
                    idUserCRM: user.PER_ID,
                    toViewAll: this.props.whatsapp.toViewAll
                }
                result = await whatsappController.getMessagesByClosedCalled(fields);
            }
            else
            {
                result = await whatsappController.getAllChats(
                    amount,
                    valueSearching,
                    this.props.idUserCRM,
                    this.props.user.PER_ID,
                    this.props.whatsapp.toViewAll,
                    activeCheckMyOwnCalledsFilter,
                    activeCheckClosedCalledsFilter
                );
            }

            if (result.status)
            {
                let {data} = result.data;
                chats = data;
                localStorage.setItem("ALL_CHATS_REALTIME", JSON.stringify(data));
            }
        }
        else
        {
            let cache = await localStorage.getItem("ALL_CHATS_REALTIME");
            if (cache) { chats = JSON.parse(cache); }
        }

        // let pendingScrollToEndMessages = await this.state.pendingScrollToEndMessages;
        let idOpenedChat = await this.state.idOpenedChat;

        chats = chats.map(c => {
            let messages = c.messages;
            let lastMessage = messages[messages.length - 1];
            let stamp = formatedDateTimeToBrowserAtAnyTime(lastMessage.datetime);
            let oldChat = oldChats.filter(o => o.idContact === c.idContact);
            let amountBeforeCalleds = 0;
            stamp = stamp.getTime();

            let message = lastMessage.message;

            if (oldChat.length >= 0)
            {
                oldChat = oldChat[0];
                amountBeforeCalleds = (oldChat?.amountBeforeCalleds) ? oldChat.amountBeforeCalleds : 0;
            }

            if (lastMessage.type === DOCUMENT) { message = lastMessage.file.name; }
            else if (lastMessage.type === IMAGE) { message = (message === "") ? "Foto" : message; }
            else if (lastMessage.type === AUDIO) { message = (message === "") ? "Áudio" : message; }

            c.sentForMeLastMessage = lastMessage.sentForMe;
            c.isDeletedLastMessage = lastMessage.isDeleted;
            c.messageLastMessage = message;
            c.typeLastMessage = lastMessage.type;
            c.datetimeLastMessage = lastMessage.datetime;
            c.stampLastMessage = stamp;
            c.statusLastMessage = lastMessage.status; //0 for not exit status (deleted message), 1 for sent, 2 for delivered, and 3 for read/heard
            c.idDepartament = lastMessage.idDepartament;
            c.amountBeforeCalleds = amountBeforeCalleds;

            return c;
        });

        if (chats.length === 0) { await this.setState({chats: []}); }

        // ... if exists any opened chat.
        if (idOpenedChat && chats.length > 0)
        {
            let idOpenedContact = await this.state.idOpenedChat;
            await this.openChat(chats, idOpenedContact);
            await this.setState({pendingScrollToEndMessages: false});
        }

        if (!idOpenedChat)
        {
            await this.setState({chats});
        }

        // setting all chats and their messages
        await this.setState({gettingChats: false});
    }
    
    getAllDepartaments = async () =>
    {
        let idServiceDigiSac = await this.state.idServiceDigiSac;
        let optionsDepartaments = [];
        let response = await whatsappController.getAllDepartaments(idServiceDigiSac);

        if (response.status)
        {
            let {data} = response.data;

            for (let i = 0; i < data.length; i++)
            {
                let departament = data[i];
                optionsDepartaments.push(
                    {
                        value: departament.depId,
                        name: departament.depName,
                        checked: false
                    }
                );
            }
        }

        await this.setState({optionsDepartaments, optionsDepartamentsFiltered: optionsDepartaments});
    }

    getUsersByDepartament = async (id) =>
    {
        let optionsUsersFromtDepartaments = [];
        let response = await whatsappController.getUsersByDepartament(id);

        if (response.status)
        {
            let {data} = response.data;

            for (let i = 0; i < data.length; i++)
            {
                let user = data[i];
                optionsUsersFromtDepartaments.push(
                    {
                        value: user.id,
                        name: user.name,
                        checked: false
                    }
                );
            }
        }

        await this.setState({optionsUsersFromtDepartaments});
    }

    checkingUserWithMultipleDepartaments = async () =>
    {
        let responseMultiple = await whatsappController.checkingUserWithMultipleDepartaments(this.props.user.PER_ID);
        let isUserWithMultipleDepartaments = false;

        if (responseMultiple.status) { isUserWithMultipleDepartaments = responseMultiple.data.multiple; }

        await this.setState({isUserWithMultipleDepartaments});
    }

    handleScrollChatList = async () =>
    {
        let gettingChats = await this.state.gettingChats;
        let areaScrollElement = this.chatList.current;
        let alreadyScrolled = parseInt(areaScrollElement.scrollTop);
        let minimumToScroll = parseInt(MINIMUM_CHATS_TO_LOAD / 4 * HEIGHT_ITEM_CHAT * CONST_MINIMUM_CHATS_TO_LOAD);
        // INFORMATION: don't remove; for maintenance
        // let output = "";
        
        if (alreadyScrolled >= minimumToScroll && alreadyScrolled >= AMOUNT_SCROLLED_CHAT_LIST)
        {
            AMOUNT_SCROLLED_CHAT_LIST = minimumToScroll;
            if (!gettingChats) 
            { 
                // INFORMATION: don't remove; for maintenance
                // output = "getting more chats...";

                CONST_MINIMUM_CHATS_TO_LOAD++;
                await this.getAllChatsRealtime();
            }
            else
            {
                // INFORMATION: don't remove; for maintenance
                // output = "no yet...";
            }
        }
        else
        {
            // INFORMATION: don't remove; for maintenance
            // output = `gettingChats: ${gettingChats}, alreadyScrolled: ${alreadyScrolled}, minimumToScroll: ${minimumToScroll}, AMOUNT_SCROLLED_CHAT_LIST: ${AMOUNT_SCROLLED_CHAT_LIST}, CONST_MINIMUM_CHATS_TO_LOAD: ${CONST_MINIMUM_CHATS_TO_LOAD}`;
        }

        // INFORMATION: don't remove; for maintenance
        // await this.setState({outputVisible: true, outputContent: output});
    }

    scrollToBottom = async () =>
    {
        let areaScrollElement = this.conversationMessagesPanel.current;
        let maxToScroll = areaScrollElement.scrollHeight;
        this.conversationMessagesPanel.current.scrollTop = maxToScroll;
    }

    handleScrollConversationMessagesPanel = async (event) =>
    {
        let areaScrollElement = this.conversationMessagesPanel.current;
        let alreadyScrolled = parseInt(areaScrollElement.scrollTop);
        let heightView = areaScrollElement.clientHeight;
        let maxToScroll = areaScrollElement.scrollHeight;
        let diff = (maxToScroll - alreadyScrolled);
        let activeButtonScrollToBottom = false;

        if (diff > (3 * heightView)) { activeButtonScrollToBottom = true;  }

        await this.setState({activeButtonScrollToBottom});
    }

    handleKeyPress = (event) => 
    {
        if (event.key === "Escape") { this.closeDropAreaAswerMessage(); }
    }

    handleClickOutSide = (event) =>
    {
        if
        (
            this.inputSearching && 
            !this.inputSearching.current.contains(event.target) && 
            this.state.valueSearching.toString().trim() === ""
        )
        { this.setState({activeButtonBackChatList: false}); }
  
        if
        (
            this.buttonMoreOptionsAttachments &&
            !this.buttonMoreOptionsAttachments.current?.contains(event.target) &&
            !this.dropdownOptionsAttachments.current?.contains(event.target)
        )
        { this.setState({activeDropdownMoreActionsAttachments: false}); }

        if (this.buttonMoreOptions && !this.buttonMoreOptions.current.contains(event.target))
        { this.setState({activeButtonMoreOptions: false, activeDropdownMoreOptions: false}); }
    }

    formatedDateTimeContact = (datetime) =>
    {
        if (datetime === null) { return ""; }
        let partsDateContact = datetime.split(" ");
        let dateContact = partsDateContact[0];

        let partsDate = dateContact.split("-");
        let yearDate = partsDate[0];
        let monthDate = partsDate[1];
        let dayDate = partsDate[2];

        let dateInstanceToday = getDateTimeCurrentBrowserAtMidnight();
        let dateToday = formatedDateTimeToUSA(dateInstanceToday);
        let dateInstanceYestarday = getPreviousDateTimeCurrentBrowserAtMidnight(1);
        let dateYestarday = formatedDateTimeToUSA(dateInstanceYestarday);
        
        // today...
        if (dateContact === dateToday) { return `Hoje`; }

        // yestarday...
        if(dateContact === dateYestarday) { return "Ontem"; }

        // last week...
        let weeks = [];
        for (let i = 1; i <= 7; i++) 
        {
            let dayWeek = getPreviousDateTimeCurrentBrowserAtMidnight(i);
            let indexWeek = dayWeek.getDay();
            weeks.push(
                {
                    indexWeek,
                    dayWeek: formatedDateTimeToUSA(dayWeek),
                    nameWeek: days.filter(o => o.order === indexWeek)[0].dayBRA
                }
            );            
        }

        let isDayILastWeek = weeks.filter(w => w.dayWeek === dateContact);
        if (isDayILastWeek.length > 0) { return isDayILastWeek[0].nameWeek; }

        // another day...
        return `${dayDate}/${monthDate}/${yearDate}`;
    }

    getMessagesByContactChat = async () =>
    {
        let messagesBeforeFromMe = [];
        let messagesBeforeOther = [];
        let initialFromMe = false;
        let initialFromOther = false;
        let indexOpenedChat = await this.state.indexOpenedChat;
        let chats = await this.state.chats;
        let pendingScrollToAnswerMessage = await this.state.pendingScrollToAnswerMessage;
        let idMessageToScrollAnswerMessage = await this.state.idMessageToScrollAnswerMessage;
        let chat = chats.filter((c, i) => i === indexOpenedChat)[0];
        let message = null;
        let dateBefore = "";
        let departamentBefore = "";
        let dateCalleStartBefore = "";
        let dateCalleEndsBefore = "";
        let messagesByChatComponents = [];
        let statusCalled = null;
        let idDepartament = "";
        let idCalled = "";
        let idServiceDigiSac = "";
        let cellphoneNumberClient = "";
        let idUserCRMFromCalled = null;
        let nameUserCRMFromCalled = null;
        let infosCalled = {};

        messagesByChatComponents = chat?.messages?.map((m, index) => {
            let date = "";
            let departament = "";
            let dateCalleStart = "";
            let dateCalleEnds = "";
            let partsDateMessage = m.datetime.split(" ");
            let dateMessage = partsDateMessage[0];
            let departamentMessage = "";
            let dateCalleStartMessage = "";
            let dateCalleEndsMessage = "";
            let lastIndexOccurenceClosedCalled = chat.messages.findLastIndex(l => l.calledDateTimeEnds === m.calledDateTimeEnds);

            cellphoneNumberClient = (m.sentForMe) ? m.cellphoneNumberDestination : m.cellphoneNumberOrigin;

            if (m.idCalled) { idCalled = m.idCalled; } //DANGER: don't to set empty string, because is not exists on temporary message...
            if (m.idServiceDigiSac) { idServiceDigiSac = m.idServiceDigiSac; } //DANGER: don't to set empty string, because is not exists on temporary message...
            if (m.statusCalled) { statusCalled = m.statusCalled; } //DANGER: don't to set empty string, because is not exists on temporary message...
            if (m.idDepartament) { idDepartament = m.idDepartament; } //DANGER: don't to set empty string, because is not exists on temporary message...
            if (m.idUserCRM) { idUserCRMFromCalled = m.idUserCRM; } //DANGER: don't to set empty string, because is not exists on temporary message...
            if (m.nameUserCRM) { nameUserCRMFromCalled = m.nameUserCRM; } //DANGER: don't to set empty string, because is not exists on temporary message...
            if (m.calledDateTimeStart) { dateCalleStartMessage = `Aberto em: ${m.calledDateTimeStart}`; }

            if (m.nameUserCRM && m.nameDepartament)
            {
                departamentMessage = `${m.nameUserCRM}, do(a) ${m.nameDepartament}, ${m.nameCompanyUnit}`;
                infosCalled.idCalled = m.idCalled;
                infosCalled.nameAttendantCalled = m.nameUserCRM;
                infosCalled.idDepartamentCalled = m.idDepartament;
                infosCalled.nameDepartamentCalled = m.nameDepartament;
                infosCalled.nameCompanyUnitCalled = m.nameCompanyUnit;
            }
            
            if (m.calledDateTimeEnds && m.statusCalled === 2)
            {
                if (lastIndexOccurenceClosedCalled === index)
                {
                    dateCalleEndsMessage = `Fechado em: ${m.calledDateTimeEnds}`;
                }
            }

            if (dateMessage !== dateBefore) 
            { 
                date = this.formatedDateTimeContact(m.datetime);
                dateBefore = dateMessage;
            }

            if (departamentMessage !== departamentBefore)
            { 
                departament = departamentMessage;
                departamentBefore = departamentMessage;
            }

            if (dateCalleStartMessage !== dateCalleStartBefore)
            {
                dateCalleStart = dateCalleStartMessage;
                dateCalleStartBefore = dateCalleStartMessage;
            }

            if (dateCalleEndsMessage !== dateCalleEndsBefore)
            {
                dateCalleEnds = dateCalleEndsMessage;
                dateCalleEndsBefore = dateCalleEndsMessage;
            }

            if (m.sentForMe && messagesBeforeFromMe.length === 0)
            {
                messagesBeforeFromMe.push(index);
                initialFromMe = true;
            }
            else
            {
                initialFromMe = false;
            }

            if (!m.sentForMe && messagesBeforeOther.length === 0)
            {
                messagesBeforeOther.push(index);
                initialFromOther = true;
            }
            else
            {
                initialFromOther = false;
            }

            if (!m.sentForMe) { messagesBeforeFromMe = []; }
            if (m.sentForMe) { messagesBeforeOther = []; }

            switch (m.type)
            {
                case DOCUMENT:
                    message =  (
                        <MessageDocumentWhatsApp
                            key={index}
                            initial={initialFromMe || initialFromOther}
                            openDropdownActionsMessages={this.openDropdownActionsMessages}
                            scrollToAnswerMessage={this.scrollToAnswerMessage}
                            onDownload={this.onDownload}
                            {...m}
                        />
                    );
                    break;

                case TEXT:
                    message =  (
                        <MessageTextWhatsApp
                            key={index}
                            initial={initialFromMe || initialFromOther}
                            openDropdownActionsMessages={this.openDropdownActionsMessages}
                            scrollToAnswerMessage={this.scrollToAnswerMessage}
                            {...m}
                        />
                    );
                    break;

                case IMAGE:
                    message =  (
                        <MessageImageWhatsApp
                            key={index}
                            initial={initialFromMe || initialFromOther}
                            openDropdownActionsMessages={this.openDropdownActionsMessages}
                            scrollToAnswerMessage={this.scrollToAnswerMessage}
                            {...m}
                        />
                    );
                    break;
            
                case AUDIO:
                    message =  (
                        <MessageAudioWhatsApp
                            key={index}
                            initial={initialFromMe || initialFromOther}
                            avatarOrigin={this.state.hasAvatar}
                            userOrigin={this.props.user}
                            openDropdownActionsMessages={this.openDropdownActionsMessages}
                            scrollToAnswerMessage={this.scrollToAnswerMessage}
                            onDownloadAudio={this.onDownloadAudio}
                            onTooglePlayAudio={this.onTooglePlayAudio}
                            onSetStatusPlayed={this.onSetStatusPlayed}
                            setMaximumDurationTimeAnswerAudio={this.setMaximumDurationTimeAnswerAudio}
                            setMaximumDurationTimeAudio={this.setMaximumDurationTimeAudio}
                            {...m}
                        />
                    );
                    break;

                default:
                    break;
            }

            return (
                <div className="groupMessagesWhatsApp" key={index}>
                    {
                        date !== "" &&
                        <div className="areaDataWhatsApp">
                            <span className="dataMessageWhatsApp">{date}</span>
                        </div>
                    }
                    {
                        dateCalleStart !== "" &&
                        <div className="areaDataWhatsApp">
                            <span className="dataMessageWhatsApp">{dateCalleStart}</span>
                        </div>
                    }
                    {
                        departament !== "" &&
                        <div className="areaDataWhatsApp">
                            <span className="dataMessageWhatsApp">{departament}</span>
                        </div>
                    }
                    {message}
                    {
                        dateCalleEnds !== "" &&
                        <div className="areaDataWhatsApp">
                            <span className="dataMessageWhatsApp">{dateCalleEnds}</span>
                        </div>
                    }
                </div>
            );
        });

        await this.setState(
            {
                idCalled,
                infosCalled,
                statusCalled,
                idDepartament,
                idServiceDigiSac,
                idUserCRMFromCalled,
                nameUserCRMFromCalled,
                cellphoneNumberClient,
                messagesByChatComponents,
            }
        );

        if (pendingScrollToAnswerMessage) { await this.scrollToAnswerMessage(idMessageToScrollAnswerMessage); }

        await this.getAllDepartaments();
    }

    loadOldMessagesByContactChat = async () =>
    {
        console.log("getting the old messages...");

        let indexOpenedChat = await this.state.indexOpenedChat;
        let chats = await this.state.chats;
        let chat = chats.filter((c, i) => i === indexOpenedChat)[0];
        let idContact = chat.idContact;

        chats = chats.map(c => {

            if (c.idContact === chat.idContact)
            {
                c.amountBeforeCalleds = (c?.amountBeforeCalleds) ? (c.amountBeforeCalleds + 1) : 1;
            }
            
            return c;
        });

        await this.openChat(chats, idContact);
    }

    filterChats = async () =>
    {
        let activeButtonFilter = !this.state.activeButtonFilter;
        await this.setState({activeButtonFilter});

        if (activeButtonFilter)
        {  
            await this.closeChat();
            await this.setState({chatsFiltered: [], chats: []}); 
        }
        else 
        { 
            await this.getAllChatsRealtime();
        }
    }

    openDropdownItemList = async (props, event, type) =>
    {
        let top = event.clientY;
        let left = event.clientX;
        let dropdownHeight = this.dropdownItemList.dropdownRef.current.clientHeight;
        let screenHeight = event.view.innerHeight;
        let effectDropdownItemList = "activeLeftTop";
        
        if (type === "OUTSIDE")
        {
            top = top + 10;
            left = left - 45;
        }

        if (type === "INSIDE")
        {
            top = props.top + 20;
            left = props.left - 38;
        }

        // @OVERWRITE
        if ((dropdownHeight + top) >= screenHeight) 
        { 
            top = top - dropdownHeight - 20;
            effectDropdownItemList = "activeLeftBottom";
        }

        let styleDropdownItemList = {top, left};

        let messagesItemList = props.messages;
        let lastMessagesItemList = (messagesItemList.length > 0) ? messagesItemList[messagesItemList.length - 1] : null;
        let idCalledItemList = null;

        if (lastMessagesItemList?.idUserCRMFromMessage === this.props.user.PER_ID)
        {
            idCalledItemList = (lastMessagesItemList) ? lastMessagesItemList.idCalled : null;
        }

        await this.setState(
            {
                idCalledItemList,
                styleDropdownItemList, 
                activeDropdownItemList: !this.state.activeDropdownItemList,
                effectDropdownItemList
            }
        );
    }

    openDropdownActionsMessages = async (props, event) =>
    {
        let stampNow = new Date().getTime();
        let stampOld = (props.stamp + (30 * 60 * 1000));

        let showOptionsEditingDropdownActionsMessage = (props.sentForMe && props.type === TEXT && (stampNow <= stampOld));
        let showOptionDeleteDropdownActionsMessage = props.sentForMe;

        await this.setState({showOptionDeleteDropdownActionsMessage, showOptionsEditingDropdownActionsMessage});

        let top = props.top;
        let left = props.left;
        let dropdownWidth = this.dropdownActionsMessages.dropdownRef.current.clientWidth;
        let dropdownHeight = this.dropdownActionsMessages.dropdownRef.current.clientHeight;        
        let effectDropdownActionsMessage = "activeRightTop";
        let window = getWindowDimensions();
        let windowHeight = window.height;
        
        top = (top + 18);

        if (top > (windowHeight / 2))
        {
            top = (top - dropdownHeight - 17);
            effectDropdownActionsMessage = "activeRightBottom";
        }

        let styleDropdownActionsMessages = {
            top,
            left: (left - dropdownWidth + 17)
        };

        await this.setState(
            {
                styleDropdownActionsMessages,
                activeDropdownActionsMessages: !this.state.activeDropdownActionsMessages,
                effectDropdownActionsMessage,
                targetMessageMoreActionContactChat: props,
                objMessageTargetByDropdownActions: {id: props.id, message: props.message}
            }
        );
    }

    onDownloadAudio = async (props) =>
    {
        let chats = await this.state.chats;

        chats = chats.map(c => {
            c?.messages.map(m => {
                if (props.id === m.id)
                {
                    m.file.path = m.file.download;
                    m.file.download = "";
                    m.message = `new ${m.message}`;
                }
                return m;
            });
            return c;
        });

        await this.setState({chats});
        await this.getMessagesByContactChat();
    }

    onTooglePlayAudio = async (props) =>
    {
        let chats = await this.state.chats;

        chats = chats.map(c => {
            c?.messages.map(m => {
                if (m.type === AUDIO)
                {
                    if (m.id === props.id)
                    {
                        m.playing = !m.playing;
                        m.focused = true;
                    }
                    else
                    {
                        m.playing = false;
                        m.focused = false;
                    }
                }
                return m;
            });
            return c;
        });

        await this.setState({chats});
        await this.getMessagesByContactChat();
    }

    onSetStatusPlayed = async (props, status) =>
    {
        let chats = await this.state.chats;

        chats = chats.map(c => {
            c?.messages.map(m => {
                if (m.type === AUDIO)
                {
                    if (m.id === props.id)
                    {
                        m.playing = status;
                        m.focused = true;
                    }
                    else
                    {
                        m.playing = false;
                        m.focused = false;
                    }
                }
                return m;
            });
            return c;
        });

        await this.setState({chats});
        await this.getMessagesByContactChat();
    }

    setMaximumDurationTimeAnswerAudio = async (props, time) =>
    {
        let idContact = props.idContact;
        let idMessage = props.id;
        let messagesFromChats = await this.state.messagesByChat;
        messagesFromChats = messagesFromChats.map(m => {

            if (m.idContact === idContact && m.type === AUDIO)
            {
                if (m.id === idMessage)
                {
                    m.answer.message = time;
                }
            }

            return m;
        });
        
        await this.setState({messagesFromChats});
        await this.getMessagesByContactChat();
    }

    setMaximumDurationTimeAudio = async (props, time) =>
    {
        let chats = await this.state.chats;

        chats.map(c => {
          
            c?.messages.map(async (m) => {
                
                if (m.type === AUDIO && m.duration === 0) { await whatsappController.setAudioDuration(m.id, Math.trunc(time)); }

                return m;
            });

            return c;
        });
    }

    closeDropAreaAswerMessage = async () =>
    {
        await this.setState({activeAnswerMessage: false, answerMessage: ANSWER_MESSAGE_DEFAULT})
    }

    getFormatedDuration = (duration) =>
    {
        let durationNumber = parseInt(duration);
        let hours   = Math.floor(durationNumber / 3600);
        let minutes = Math.floor((durationNumber - (hours * 3600)) / 60);
        let seconds = durationNumber - (hours * 3600) - (minutes * 60);

        if (duration < 60) //haven't a minute
        {
            seconds = seconds.toString().padStart(2, "0");
            return `0:${seconds}`;
        }
        
        if (duration > 60 && duration < 3600) //have a minute, but haven't a hour
        {
            seconds = seconds.toString().padStart(2, "0");
            return `${minutes}:${seconds}`;
        }
        
        if (duration > 3600) //have a hour
        {
            seconds = seconds.toString().padStart(2, "0");
            minutes = minutes.toString().padStart(2, "0");
            return `${hours}:${minutes}:${seconds}`;
        }
    }

    replyToMessage = async () =>
    {
        let targetMessage = await this.state.targetMessageMoreActionContactChat;
        let idOpenedChat = await this.state.idOpenedChat;
        let chats = await this.state.chats;

        let targetChat = chats.filter(c => c.idContact === idOpenedChat);
        let answerMessage = ANSWER_MESSAGE_DEFAULT;

        delete answerMessage.file;
        answerMessage.id = targetMessage.id;
        answerMessage.name = (targetMessage.sentForMe) ? "Você" : targetChat[0].nameContact;
        answerMessage.message = targetMessage.message;
        answerMessage.type = "";
        
        if (targetMessage.type === IMAGE) 
        { 
            answerMessage.message = (targetMessage.message === "") ? "Foto" : targetMessage.message; 
            answerMessage.type = IMAGE;
        }
        
        if (targetMessage.type === AUDIO) 
        { 
            answerMessage.message = this.getFormatedDuration(targetMessage.duration); 
            answerMessage.type = AUDIO;
            answerMessage.path = targetMessage.file;
        }

        if (targetMessage.type === DOCUMENT)
        {
            answerMessage.message = (targetMessage.message === "") ? targetMessage.file.name : targetMessage.message;
            answerMessage.type = DOCUMENT;
        }

        if (targetMessage.file) { answerMessage.file = targetMessage.file; }

        await this.setState({answerMessage, activeAnswerMessage: true, activeDropdownActionsMessages: false});
        this.inputSending?.focus();
    }

    isEmpty = (object) =>
    {
        return Object.keys(object).length === 0;
    }

    openChat = async (chats, idContact, manually = false) =>
    {
        let chat = {};
        let indexOpenedChat = 0;
        let oldChats = await this.state.chats;
        let activeFilterByParamsURL = await this.state.activeFilterByParamsURL;
        let idLastCalledOpenedChat = await this.state.idLastCalledOpenedChat;
        let audioRecord = await this.state.audioRecord;
        let lastMessage = {};
        let idCalled = "";
        let idDepartament = "";
        let idUserCRMOnAccess = "";
        let toViewAll = "";
        let amountBeforeCalleds = null;

        chats.forEach((c, i) => {

            let chatInternal = c;
            let lastMessageInternal = chatInternal.messages[chatInternal.messages.length - 1];
            let idLastCalledInternal = lastMessageInternal.idCalled;

            if (c.idContact === idContact && parseInt(idLastCalledOpenedChat) === parseInt(idLastCalledInternal)) 
            {
                chat = c;
                indexOpenedChat = i;

                if (c?.amountBeforeCalleds) { amountBeforeCalleds = c.amountBeforeCalleds; }
            }
        });

        if (isEmpty(chat)) { return; } //WARNING: don't remove, because the chat is empty (Unable to find the chat that was opened)

        lastMessage = chat.messages[chat.messages.length - 1];
        
        idCalled = lastMessage.idCalled;
        idDepartament = lastMessage.idDepartament;
        idUserCRMOnAccess = this.props.user.PER_ID;
        toViewAll = this.props.whatsapp.toViewAll;

        let responseMessages = await whatsappController.getMessagesByChat(
            idCalled,
            idDepartament,
            idUserCRMOnAccess,
            idContact,
            toViewAll,
            amountBeforeCalleds,
            activeFilterByParamsURL
        );

        if (responseMessages.status)
        {
            let messagesByChat = responseMessages.data.data;

            chats = chats.map((c, i) => {
                if (c.idContact === idContact && indexOpenedChat === i) 
                {
                    c.messages = messagesByChat.map(m => {

                        // some audio playing?
                        if (m.type === AUDIO)
                        {
                            let oldChatEqual = oldChats.filter(oc => (oc.idContact === c.idContact));
                            
                            if (oldChatEqual.length > 0)
                            {
                                let oldMessagesByChatEqual = oldChatEqual[0].messages;
                                let oldAudioMessagesByChatEqual = oldMessagesByChatEqual.filter(om => (om.id === m.id));

                                if (oldAudioMessagesByChatEqual.length > 0)
                                {
                                    let audioMessage = oldAudioMessagesByChatEqual[0];
                                    m.playing = audioMessage.playing;
                                }
                            }
                        }

                        return m;
                    });
                }

                return c;
            });
        }

        await this.setState(
            {
                chats,
                openedChat: true,
                idOpenedChat: idContact,
                indexOpenedChat,
                nameContactChat: `${chat.nameContact} ${chat.isChatFromMe ? "(você)" : ""}`,
                cellphoneContactChat: (chat.nameContact === chat.cellphoneContact) ? chat.nicknameContact : chat.cellphoneContact,
                photoContactChat: chat.photoContact,
                timeContactChat: "online",
                nameConnection: chat.nameConnection
            }
        );

        await this.setDimensionsWhatsApp();
        await this.getMessagesByContactChat();

        if (manually)
        {
            await this.setState(
                {
                    activeAnswerMessage: false,
                    answerMessage: {name: "", message: ""},
                    valueSending: ""
                }
            )

            this.scrollToEndMessages(true);

            if (audioRecord) { await this.deleteRecordingAudio(); }
        }

        this.scrollToEndMessages();
        // this.inputSending.focus();
        // this.closeUploadFile();

        let idUserCRMFromCalled = await this.state.idUserCRMFromCalled;

        if (parseInt(this.props.user.PER_ID) === parseInt(idUserCRMFromCalled) && manually)
        { await whatsappController.updateNotReadCalledsAndMessages(idUserCRMFromCalled, idCalled); }

        // INFORMATION: forcing the reset...
        chat = {};
    }

    closeChat = async () => 
    {
        await this.closeProfile();
        await this.setState({...CLOSED_CHAT});
    }

    closeUploadFile = async () =>
    {
        await this.setState({...CLOSED_UPLOAD_FILE_CHAT});
    }

    scrollToEndMessages = (directly = false) =>
    {
        let panel = this.conversationMessagesPanel.current;

        if (!panel) { return; }

        let maxHeight = panel.scrollHeight;
        let scrollTop = panel.scrollTop;
        let clientHeight = panel.clientHeight;

        let messageGroups = panel.getElementsByClassName("groupMessagesWhatsApp");
        if (messageGroups.length === 0) { return; }
    
        let lastMessageGroup = messageGroups[messageGroups.length - 1];
        let lastMessageHeight = lastMessageGroup.offsetHeight;
    
        if (!directly)
        {
            if ((scrollTop + clientHeight + lastMessageHeight + 10) >= maxHeight) //10px; is security margin
            {
                if (maxHeight) { panel.scrollTo({top: maxHeight}); }
            }
        }
        else
        {
            if (maxHeight) { panel.scrollTo({top: maxHeight}); }
        }
    }

    scrollToAnswerMessage = async (id) =>
    {
        let messages = this.conversationMessagesPanel.current.childNodes;
        let chats = await this.state.chats;

        let found = false;

        messages.forEach(m => {
            
            let component = m.getElementsByClassName("messageWhatsApp");

            if (component.length > 0)
            {
                let idMessage = component[0].getAttribute("data-id");
                
                if (idMessage === id)
                {
                    let positionFromTop = m.offsetTop;
                    this.conversationMessagesPanel.current.scrollTo({top: positionFromTop});
                    found = true;
                }
            }
        });

        if (found)
        {
            function setEmphasis (status)
            {
                return chats.map(c => {
                    c.messages = c?.messages.map(m => {
                        if (m.id === id) 
                        { m.emphasis = status; }
                        return m;
                    });

                    return c;
                });
            }

            chats = setEmphasis(true);
            await this.setState({chats, pendingScrollToAnswerMessage: false, idMessageToScrollAnswerMessage: null});
            await this.getMessagesByContactChat();
            
            setTimeout(async () => {
                chats = setEmphasis(false);
                await this.setState({chats});
                await this.getMessagesByContactChat();
            }, 980);
        }
        else
        {            
            let result = await whatsappController.getAmountScreenshotToAnswerMessage(id);

            if (result.status)
            {
                let {amountMessagesToLoad, idContactOrigin, idContactDestination} = result.data.data;

                chats = chats.map(c => {
                    if (c.idContact === idContactOrigin || c.idContact === idContactDestination) { c.amountMessagesLoaded = amountMessagesToLoad; }
                    return c;
                });

                await this.setState({chats, pendingScrollToAnswerMessage: true, idMessageToScrollAnswerMessage: id});
                await this.getAllChatsRealtime();
            }
        }
    }

    onDownload = async (message) =>
    {
        this.downloadFile(message.file.path);
    }

    getCurrentDateTimeUSA = () =>
    {
        return getDateTimeCurrentBrowserUSA();
    }

    getPreviewFromUploadFile = () =>
    {
        let extension = this.state.extensionFileUploadChat;
        let pathFileUploadChat = this.state.pathFileUploadChat;

        switch (extension) 
        {
            case XLS:
                return (<svg viewBox="0 0 110 88" height="88" width="110" preserveAspectRatio="xMidYMid meet" className="iconConversationPanelUplodaBodyWhatsApp"><defs><path d="M3 0h80.928a5 5 0 0 1 3.536 1.464l15.072 15.072A5 5 0 0 1 104 20.07V77a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z" id="a"></path></defs><g transform="translate(4 3)" className="" fillRule="evenodd"><use fill="#000" filter="url(#filter-3)" xlinkrref="#a"></use><use fill="#FFF" xlinkHref="#a"></use><path strokeOpacity="0.08" stroke="#000" d="M3-.5h80.929a5.5 5.5 0 0 1 3.889 1.61l15.071 15.072a5.5 5.5 0 0 1 1.611 3.89V77a3.5 3.5 0 0 1-3.5 3.5H3A3.5 3.5 0 0 1-.5 77V3A3.5 3.5 0 0 1 3-.5z" fill="url(#linearGradient-1)"></path><rect fillOpacity="0.2" fill="#000" x="14" y="22" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="34" y="22" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="54" y="22" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="74" y="22" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="14" y="12" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="34" y="12" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="54" y="12" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="74" y="12" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="14" y="32" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="34" y="32" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="54" y="32" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="74" y="32" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="14" y="42" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="34" y="42" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="54" y="42" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="74" y="42" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="14" y="52" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="34" y="52" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="54" y="52" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="74" y="52" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="14" y="62" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="34" y="62" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="54" y="62" width="16" height="6" rx="0.5"></rect><rect fillOpacity="0.1" fill="#000" x="74" y="62" width="16" height="6" rx="0.5"></rect><path d="M85.5.5v15a3 3 0 0 0 3 3h15" strokeOpacity="0.12" stroke="#000" fill="#FFF"></path></g></svg>);

            case DOC:
            case DOCX:
                return (<svg viewBox="0 0 88 110" height="110" width="88" preserveAspectRatio="xMidYMid meet" className="iconConversationPanelUplodaBodyWhatsApp"><defs><rect id="b" x="0" y="0" width="54" height="36" rx="2.37"></rect><path d="M3 0h56.928a5 5 0 0 1 3.536 1.464l15.072 15.072A5 5 0 0 1 80 20.07V101a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z" id="a"></path></defs><g transform="translate(4 3)" fill="iconConversationPanelUplodaBodyWhatsApp" fillRule="evenodd"><use fill="#000" filter="url(#filter-3)" xlinkHref="#a"></use><use fill="#FFF" xlinkHref="#a"></use><path strokeOpacity="0.08" stroke="#000" d="M3-.5h56.929a5.5 5.5 0 0 1 3.889 1.61l15.071 15.072a5.5 5.5 0 0 1 1.611 3.89V101a3.5 3.5 0 0 1-3.5 3.5H3A3.5 3.5 0 0 1-.5 101V3A3.5 3.5 0 0 1 3-.5z" fill="url(#linearGradient-1)"></path><rect fillOpacity="0.2" fill="#000" x="13" y="84" width="54" height="2" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="13" y="89" width="27" height="2" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="13" y="24" width="54" height="2" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="13" y="29" width="54" height="2" rx="0.5"></rect><rect fillOpacity="0.2" fill="#000" x="13" y="34" width="40" height="2" rx="0.5"></rect><g><g transform="translate(13 42)"><mask id="c" fill="#fff"><use xlinkHref="#b"></use></mask><use fillOpacity="0.1" fill="#000" xlinkHref="#b"></use><circle fillOpacity="0.1" fill="#000" mask="url(#c)" cx="37.5" cy="11.5" r="5.5"></circle><path d="m34.565 31.195 7.912-7.89a2.37 2.37 0 0 1 3.348 0l25.144 25.073L44.15 75.119l-19.556-19.5-11.259 11.228-26.817-26.742 25.143-25.072a2.37 2.37 0 0 1 3.348 0l16.208 16.162a2.37 2.37 0 0 0 3.347 0z" fillOpacity="0.1" fill="#000" mask="url(#c)"></path></g></g><path d="M61.5.5v15a3 3 0 0 0 3 3h15" strokeOpacity="0.12" stroke="#000" fill="#FFF"></path></g></svg>);

            case JPG:
            case PNG:
                return (<img className="imageConversationPanelUploadBodyWhatsApp" src={pathFileUploadChat} alt="Pré-visualização da imagem"/>)
            default:
                return (<svg viewBox="0 0 88 110" height="110" width="88" preserveAspectRatio="xMidYMid meet" className="iconConversationPanelUplodaBodyWhatsApp"><g transform="translate(4 3)"><path strokeOpacity="0.08" stroke="#000" d="M3-.5h56.929a5.5 5.5 0 0 1 3.889 1.61l15.071 15.072a5.5 5.5 0 0 1 1.611 3.89V101a3.5 3.5 0 0 1-3.5 3.5H3A3.5 3.5 0 0 1-.5 101V3A3.5 3.5 0 0 1 3-.5z" fill="#FFF" fillRule="evenodd"></path></g><path d="M65.5 3.5v15a3 3 0 0 0 3 3h15" strokeOpacity="0.12" stroke="#000" fill="#FFF"></path></svg>);
        }
    }

    getUploadFile = () =>
    {
        this.setState({uploadModeChat: true, activeDropdownMoreActionsAttachments: false});
        let inputFile = this.inputFile;
        inputFile.current.click();
    }

    formatBytes = (bytes, decimals = 1) =>
    {
        // adapated
        // from: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
        if (!+bytes) return '0 Bytes'
    
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));    
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }

    formatExtension = (type) =>
    {
        switch (type) 
        {
            case "application/pdf":
                return PDF;

            case "application/msword":
            case "application/vnd.ms-word.document.macroEnabled.12":
            case "application/vnd.ms-word.template.macroEnabled.12":
                return DOC;
            
            case "application/vnd.ms-excel":
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
                return XLS;

            case "image/jpeg":
                return JPG;

            case "image/png":
                return PNG;

            default:
                return "";
        }
    }

    onChangeUploadFile = async (e) =>
    {
        let nameFileUploadChat = "";
        let sizeFileUploadChat = "";
        let extensionFileUploadChat = "";
        let pathFileUploadChat = "";
        let fileFileUploadChat = null;

        let file = e.target.files[0];
        let url = URL.createObjectURL(file);
        nameFileUploadChat = file.name;
        sizeFileUploadChat = this.formatBytes(file.size);
        extensionFileUploadChat = this.formatExtension(file.type);
        pathFileUploadChat = url;
        fileFileUploadChat = file;

        await this.setState(
            {
                nameFileUploadChat,
                sizeFileUploadChat,
                extensionFileUploadChat,
                pathFileUploadChat,
                fileFileUploadChat
            }
        );
    }

    getBase64 = async (url) =>
    {
        let response = await axios({
            method: "GET",
            url: url,
            responseType: "arraybuffer",
        });

        return Buffer.from(response.data, "binary").toString("base64");
    }

    sendFile = async () =>
    {
        // let messagesByChat = await this.state.messagesByChat;
        let activeAnswerMessage = await this.state.activeAnswerMessage;
        let indexOpenedChat = await this.state.indexOpenedChat;
        let chats = await this.state.chats;
        let messageFileUploadChat = await this.state.messageFileUploadChat;
        let answerMessage = await this.state.answerMessage;
        let nameFileUploadChat = await this.state.nameFileUploadChat;
        let sizeFileUploadChat = await this.state.sizeFileUploadChat;
        let extensionFileUploadChat = await this.state.extensionFileUploadChat;
        let pathFileUploadChat = await this.state.pathFileUploadChat;
        let fileFileUploadChat = await this.state.fileFileUploadChat;
        let audioRecord = await this.state.audioRecord;
        let pathAudio = await this.state.pathAudio;
        let blobAudio = await this.state.blobAudio;
        let idCalled = await this.state.idCalled;
        let idUserCRMFromCalled = await this.state.idUserCRMFromCalled;
        let idDepartament = await this.state.idDepartament;
        let idServiceDigiSac = await this.state.idServiceDigiSac;
        let userCRM = this.props.user;
        let idUserCRM = userCRM.PER_ID;
        let nameUserCRM = userCRM.PER_NAME;
        let idContact = null;
        let cellphoneNumberContact = "";
        let idDepartamentFromUserWithMultipleDepartaments = "";
        let sendedSuccess = false;

        // @OVERWRITE from pathFileUploadChat
        pathFileUploadChat = (!audioRecord) ? pathFileUploadChat : pathAudio;

        // ...getting info by contact...
        for (let i = 0; i < chats.length; i++) 
        {
            if (i === indexOpenedChat)
            {
                let chat = chats[i];
                idContact = chat.idContact;
                // idDepartament = chat.idDepartament;
                cellphoneNumberContact = chat.cellphoneNumberContact;
            }
        }

        if (pathFileUploadChat.trim() !== "")
        {
            let datetime = this.getCurrentDateTimeUSA();
            let type = DOCUMENT;

            if (extensionFileUploadChat === PNG || extensionFileUploadChat === JPG) { type = IMAGE; }

            if (audioRecord) { type = AUDIO; }

            let newMessage = {
                id: parseInt(Math.random() * 999999),
                idContact,
                type,
                message: messageFileUploadChat,
                datetime: datetime,
                sentForMe: true,
                status: 1,
                isDeleted: false,
                emphasis: false,
                fileProcessing: false,
                file: {
                    name: nameFileUploadChat,
                    pages: 0,
                    extension: extensionFileUploadChat,
                    size: sizeFileUploadChat,
                    path: pathFileUploadChat,
                    file: fileFileUploadChat
                }
            };

            const formData = new FormData()

            if (type === IMAGE)
            {
                formData.append("image", fileFileUploadChat);
            }
            else if (type === DOCUMENT)
            {
                formData.append("document", fileFileUploadChat);
            }
            else if (type === AUDIO)
            {
                let audio = new File([blobAudio], 'recording.ogg');
                formData.append("audio", audio);

                delete newMessage.file;

                newMessage.statusAudio = 1;
                newMessage.focused = false;
                newMessage.playing = false;
                newMessage.avatarNoMe = "";
                newMessage.idUserCRM = idUserCRM;
                newMessage.file = {
                    path: "",
                    download: pathAudio
                };
            }

            formData.append("phone", `${cellphoneNumberContact}`);
            formData.append("message", messageFileUploadChat);
            formData.append("idContact", idContact);
            formData.append("idUserCRM", idUserCRM);
            formData.append("nameUserCRM", nameUserCRM);
            formData.append("idCalled", idCalled);
            formData.append("idDepartament", idDepartament);
            formData.append("idUserCRMFromCalled", idUserCRMFromCalled);
            formData.append("idDepartamentFromUserWithMultipleDepartaments", idDepartamentFromUserWithMultipleDepartaments);
            formData.append("idServiceDigiSac", idServiceDigiSac);

            if (this.props.idUserCRM === 12432) //sending first message on bot whatsapp
            {
                await this.message("information", "Aguarde...Estamos enviando sua primeira mensagem e transferindo o chamado!");
            }

            // sending the aswer message...
            if (activeAnswerMessage)
            {
                chats = chats.map((c, i) => {
                    if (i === indexOpenedChat)
                    {
                        // WARNING: putting temporary message...    
                        let messages = c.messages;

                        newMessage = {
                            ...newMessage,
                            answer: { ...answerMessage }
                        };

                        if 
                        (
                            (answerMessage.file && answerMessage.file.extension === JPG) || 
                            (answerMessage.file && answerMessage.file.extension === PNG)
                        )
                        {
                            newMessage.answer.type = IMAGE;
                            newMessage.answer.path = answerMessage.file.path;
                        }
                        
                        if
                        (
                            (answerMessage.file && answerMessage.file.extension === DOC) || 
                            (answerMessage.file && answerMessage.file.extension === PDF) ||
                            (answerMessage.file && answerMessage.file.extension === XLS)
                        )
                        {
                            newMessage.answer.type = DOCUMENT;
                        }

                        delete newMessage.answer.file;

                        messages.push(newMessage);
                        c.messages = messages;
                    }
    
                    return c;
                });

                await this.setState(
                    {
                        chats,
                        valueSending: "",
                        activeAnswerMessage: false,
                        modeSending: AUDIO, 
                        answerMessage: ANSWER_MESSAGE_DEFAULT,
                        ...INPUT_SENDING, 
                        ...CLOSED_UPLOAD_FILE_CHAT,
                    }
                );
                await this.getMessagesByContactChat();
                this.scrollToEndMessages();

                let idMessageReference = answerMessage.id;

                formData.append("idMessageReference", idMessageReference);

                let result = null;

                if (type === IMAGE)
                {
                    result = await whatsappController.sendImage(formData);
                }
                else if (type === DOCUMENT)
                {
                    result = await whatsappController.sendDocument(formData);
                }
                else if (type === AUDIO)
                {
                    await this.deleteRecordingAudio();
                    result = await whatsappController.sendAudio(formData);
                }
                
                if (!result.status)
                { 
                    await this.closeMessage();
                    await this.message("error", "Opsssss, tivemos algum problema ao enviar sua mensagem. Contacte o TI!");
                }
                else
                {
                    sendedSuccess = true;
                }
            }

            // just a message...
            if (!activeAnswerMessage)
            {
                chats = chats.map((c, i) => {
                    if (i === indexOpenedChat)
                    {
                        // WARNING: putting temporary message...
                        let messages = c.messages;
                        messages.push(newMessage);
                        c.messages = messages;
                    }
    
                    return c;
                });
    
                await this.setState({chats, valueSending: "", modeSending: AUDIO, ...INPUT_SENDING, ...CLOSED_UPLOAD_FILE_CHAT});
                await this.getMessagesByContactChat();
                this.scrollToEndMessages();
    
                formData.append("idMessageReference", "");

                let result = null;

                if (type === IMAGE)
                {
                    result = await whatsappController.sendImage(formData);
                }
                else if (type === DOCUMENT)
                {
                    result = await whatsappController.sendDocument(formData);
                }
                else if (type === AUDIO)
                {
                    await this.deleteRecordingAudio();
                    result = await whatsappController.sendAudio(formData);
                }

                if (!result.status)
                { 
                    await this.closeMessage();
                    await this.message("error", "Opsssss, tivemos algum problema ao enviar sua mensagem. Contacte o TI!");
                }
                else
                {
                    sendedSuccess = true;
                }
            }

            this.inputFile.current.value = "";
            await this.closeUploadFile();

            if (this.props.idUserCRM === 12432 && sendedSuccess) //sending first message on bot whatsapp
            {
                await this.closeMessage();
                await this.message("success", "Obaaaaa, chamado transferido com sucesso!");
                await this.closeChat();
                this.customTimeOut(1, async () => {
                    await this.closeMessage();
                });
            }
        }
    }

    downloadFile = (url) =>
    {
        let link = document.createElement("a"); // Or maybe get it from the current document
        link.href = url;
        link.innerHTML = "download";
        link.target = "_blank";
        document.body.appendChild(link); // Or append it whereever you want
        link.click();
        link.remove();        
    }
    
    sleep = (ms) =>
    {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }

    sendMessage = async () =>
    {
        let activeAnswerMessage = await this.state.activeAnswerMessage;
        let answerMessage = await this.state.answerMessage;
        let valueSending = await this.state.valueSending;
        let indexOpenedChat = await this.state.indexOpenedChat;
        let chats = await this.state.chats;
        let audioRecord = await this.state.audioRecord;
        let idCalled = await this.state.idCalled;
        let idServiceDigiSac = await this.state.idServiceDigiSac;
        let idUserCRMFromCalled = await this.state.idUserCRMFromCalled;
        let idDepartament = await this.state.idDepartament;
        let isCommentSending = await this.state.isCommentSending;
        let userCRM = this.props.user;
        let idUserCRM = userCRM.PER_ID;
        let nameUserCRM = userCRM.PER_NAME;
        let idContact = null;
        let cellphoneNumberContact = "";
        let idDepartamentFromUserWithMultipleDepartaments = "";
        let sendedSuccess = false;

        if (valueSending.toString().trim() === "" && !audioRecord) { return; }

        if (audioRecord)
        {
            await this.sendFile();
            return;
        }

        let newMessage = {
            id: parseInt(Math.random() * 999999),
            idContact,
            type: TEXT,
            message: valueSending,
            datetime: getDateTimeCurrentBrowserUSA(),
            sentForMe: true,
            status: 1,
            isDeleted: false,
            emphasis: false,
            isComment: isCommentSending
        }

        // ...getting info by contact...
        for (let i = 0; i < chats.length; i++) 
        {
            if (i === indexOpenedChat)
            {
                let chat = chats[i];
                idContact = chat.idContact;
                cellphoneNumberContact = chat.cellphoneNumberContact;
            }
        }

        if (this.props.idUserCRM === 12432) //sending first message on bot whatsapp
        {
            await this.message("information", "Aguarde...Estamos enviando sua primeira mensagem e transferindo o chamado!");
        }

        // just a message...
        if (!activeAnswerMessage)
        {
            chats = chats.map((c, i) => {
                if (i === indexOpenedChat)
                {
                    // WARNING: putting temporary message...
                    let messages = c.messages;
                    messages.push(newMessage);
                    c.messages = messages;
                }

                return c;
            });

            await this.setState({
                chats,
                valueSending: "",
                isCommentSending: false,
                modeSending: AUDIO,
                ...INPUT_SENDING
            });
            await this.getMessagesByContactChat();
            this.scrollToEndMessages();

            await this.sleep(2000);//DANGER: forcing a delay, because if a document type message is triggered and then a text type message, immediately afterwards, in a delay, the text type message will be prepared much faster, and therefore the order will be reversed.

            let result = await whatsappController.send(
                {
                    idContact,
                    message: valueSending,
                    phone: cellphoneNumberContact,
                    idUserCRM,
                    nameUserCRM,
                    idDepartament,
                    idCalled,
                    idUserCRMFromCalled,
                    idDepartamentFromUserWithMultipleDepartaments,
                    isCommentSending,
                    idServiceDigiSac
                }
            );

            if (!result.status)
            { 
                await this.closeMessage();
                await this.message("error", "Opsssss, tivemos algum problema ao enviar sua mensagem. Contacte o TI!");
            }
            else
            { 
                sendedSuccess = true;
            }
        }
        
        // sending a message as answer to another...
        if (activeAnswerMessage)
        {
            chats = chats.map((c, i) => {
                if (i === indexOpenedChat)
                {
                    let answer = {
                        id: answerMessage.id,
                        name: answerMessage.name,
                        message: answerMessage.message
                    }

                    // WARNING: putting temporary message...
                    newMessage.idContact = c.idContact;
                    newMessage.answer = answer;

                    let messages = c.messages;
                    messages.push(newMessage);
                    c.messages = messages;
                }

                return c;
            });

            await this.setState({chats, valueSending: "", answerMessage: {...ANSWER_MESSAGE_DEFAULT}, activeAnswerMessage: false});
            await this.getMessagesByContactChat();
            this.scrollToEndMessages();

            await this.sleep(2000);//DANGER: forcing a delay, because if a document type message is triggered and then a text type message, immediately afterwards, in a delay, the text type message will be prepared much faster, and therefore the order will be reversed.

            let idMessageReference = answerMessage.id;
            let result = await whatsappController.send(
                {
                    idContact,
                    message: valueSending,
                    phone: cellphoneNumberContact,
                    idUserCRM,
                    nameUserCRM,
                    idDepartament,
                    idCalled,
                    idUserCRMFromCalled,
                    idDepartamentFromUserWithMultipleDepartaments,
                    isCommentSending,
                    idServiceDigiSac,
                    idMessageReference
                }
            );

            if (!result.status)
            {  
                await this.closeMessage();
                await this.message("error", "Opsssss, tivemos algum problema ao enviar sua mensagem. Contacte o TI!");
            }
            else
            { 
                sendedSuccess = true;
            }
        }

        if (this.props.idUserCRM === 12432 && sendedSuccess) //sending first message on bot whatsapp
        {
            await this.closeMessage();
            await this.message("success", "Obaaaaa, chamado transferido com sucesso!");
            await this.closeChat();
            this.customTimeOut(1, async () => {
                await this.closeMessage();
            });
        }
    }

    onCloseModalContent = async () =>
    {
        await this.setState({...DEFAULT_PARAMS_MODAL_CONTENT});
    }

    setModalToSendComments = async () =>
    {
        let type = "success";
        let title = "Adicionar comentário";
        let content = (
            <div>
                <textarea
                    className="fieldModalCommentsWhatsApp"
                    placeholder="...comentário" 
                    rows="5"
                    onChange={(e) => this.setState({valueCommentsSending: e.target.value})}
                />
                <br />
                <div className="lineModalCommentsWhatsApp">
                    <Button
                        classaditional="buttonModalCommentsWhatsApp error"
                        name="cancelar"
                        onClick={this.onCloseModalContent}
                    />
                    <Button
                        classaditional="buttonModalCommentsWhatsApp success"
                        name="salvar"
                        onClick={this.sendCommentsMessage}
                    />
                </div>
            </div>
        );

        await this.messageContent(type, title, content);
    }

    setValueSendigMessage = async (message) =>
    {
        let before = await this.state.valueSending;
        let after = "";

        if (before.toString().trim() === "") { after = message; }
        else { after = before + "\n" + message; }

        await this.setState({valueSending: after});
    }

    setModalToQuickMessages = async () =>
    {
        let msgs = [];
        let type = "success";
        let title = "Mensagem rápida";
        let size = "large";

        let idDepartament = await this.state.idDepartament;
        let result = await whatsappController.getQuickMessagesByDepartament(idDepartament);

        if (result.status) { msgs = result.data.data; }

        let content = (
            <div className="modalContentToQuickMessagesWhatsApp">
                <div className="lineBodyModalQuickMessagesWhatsApp">
                    {
                        msgs.map((m, i) => {
                            return (
                                <WhatsAppButtonQuickMessage
                                    key={m.id}
                                    title={m.title}
                                    message={m.message}
                                    onClick={(value) => {
                                        this.setValueSendigMessage(value);
                                        this.onCloseModalContent();
                                    }}
                                />
                            )
                        })
                    }
                    { msgs.length === 0 && "[nenhuma mensagem rápida cadastrada]" }
                </div>
            </div>
        );

        await this.messageContent(type, title, content, size);
    }

    sendCommentsMessage = async () =>
    {
        await this.onCloseModalContent();
        let valueCommentsSending = await this.state.valueCommentsSending;
        await this.setState({
            valueCommentsSending: "",
            isCommentSending: true,
            valueSending: valueCommentsSending
        });
        await this.sendMessage();
    }

    sendEditingMessage = async () =>
    {
        await this.onCloseModalContent();
        let valueEditingSending = await this.state.valueEditingSending;
        let idMessageEditingSending = await this.state.idMessageEditingSending;
        let idServiceDigiSac = await this.state.idServiceDigiSac;
        let chats = await this.state.chats;
        let indexOpenedChat = await this.state.indexOpenedChat;

        let result = await whatsappController.editMessage(idMessageEditingSending, idServiceDigiSac, valueEditingSending);

        if (!result.status)
        {
            await this.message("error", result.data.message);
        }
        else
        {
            chats = chats.map((c, i) => {
                if (i === indexOpenedChat)
                {
                    let messages = c.messages.map((m) => {
                        if (m.id === idMessageEditingSending)
                        {
                            m.message = valueEditingSending;
                            m.isEdited = true;
                        }
                        return m;
                    });
                    c.messages = messages;
                }
                return c;
            });

            await this.setState({chats});
            await this.getMessagesByContactChat();
        }

        await this.setState({idMessageEditingSending: "", valueEditingSending: ""});
    }

    startRecordingAudio = async () =>
    {
        // console.log("starting startRecordingAudio...");
        await this.setState({audioRecord: true, recording: true});
    }

    pauseRecordingAudio = async () =>
    {
        // console.log("pausing pauseRecordingAudio...");
        await this.setState({audioRecord: true, recording: false});
    }

    deleteRecordingAudio = async () =>
    {
        await this.pauseRecordingAudio();
        setTimeout(async() => { //DANGER!!! DON'T REMOVE THIS setTimeout().
            await this.setState({...AUDIO_RECORD});
        }, 1000);
    }

    setMultipleLineTextArea = async () =>
    {
        let factorHeightInputSending = await this.state.factorHeightInputSending;
        factorHeightInputSending = (factorHeightInputSending + 1);
        if (factorHeightInputSending > 3) {  return; }
        await this.setState(
            {
                factorHeightInputSending,
                minHeightInputSending: (42 * factorHeightInputSending)
            }
        );
    }

    maintenance = async () =>
    {
        await this.setState(
            {
                maintenance: true,
                openedChat: true, //default is false
                idOpenedChat: 1, //default is null
                indexOpenedChat: 0, //default is null
                nameContactChat: "em manutenção", //default is empty string
                photoContactChat: null, //default is null,
                timeContactChat: "0:00", //default is empty string
            }
        );
    }

    openProfile = async () =>
    {
        await this.setState({openedProfileChat: true});
        await this.setDimensionsWhatsApp();
    }

    closeProfile = async () =>
    {
        await this.setState({openedProfileChat: false});
        await this.setDimensionsWhatsApp();
    }

    setDimensionsWhatsApp = async () =>
    {
        let openedProfileChat = await this.state.openedProfileChat;
        let window = getWindowDimensions();
        let widthScreen = window.width;
        let widthAvaliable = (widthScreen - WIDTH_MENUS_CRM);
        let widthChatList = WIDTH_CHAT_LIST;
        let widthConversationPanel = 0;
        let widthMoreDetailsProfile = 0;

        if (widthScreen < 1920) { widthChatList = 350; }

        if (openedProfileChat) { widthMoreDetailsProfile = WIDTH_MORE_DETAILS_PROFILE; }

        if (widthScreen >= 1440)
        {
            widthConversationPanel = (widthAvaliable - widthChatList - widthMoreDetailsProfile);
            if (openedProfileChat) { widthMoreDetailsProfile = (widthAvaliable - widthChatList - widthConversationPanel); }
        }
        else
        {
            if (openedProfileChat) { widthMoreDetailsProfile = (widthAvaliable - widthChatList); }
            widthConversationPanel = (widthAvaliable - widthChatList - widthMoreDetailsProfile);
        }

        // console.log(`widthAvaliable: ${widthAvaliable}, widthChatList: ${widthChatList}, widthConversationPanel: ${widthConversationPanel}, widthMoreDetailsProfile: ${widthMoreDetailsProfile}`);

        await this.setState(
            {
                widthChatList,
                widthConversationPanel,
                widthMoreDetailsProfile
            }
        )
    }

    customTimeOut = (seconds, cb) =>
    {
        setTimeout(() => {
            cb();
        }, (seconds * 1000));
    }

    closeMessage = () =>
    {
        this.props.setModalMessage({show: false, message: "", type: "information"});
    }

	message = (type, message) =>
	{
        this.props.setModalMessage({show: true, type, message});
	}

    messageConfirmation = async (type, message) =>
    {
        await this.setState({
            message_type_confirmation: type,
            message_confirmation: message,
            message_show_confirmation: true
        });
    }

	messageContent = async (type, title, content, size = "") =>
    {
        await this.setState({
            message_show_content: true,
            message_content_content: content,
            message_type_content: type,
            message_title_content: title,
            message_size_content: size
        });
    }

    onEditMessage = async () =>
    {
        let target = await this.state.targetMessageMoreActionContactChat;
        let valueEditingSending = target.message;
        let idMessageEditingSending = target.id;
    
        await this.setState({
            valueEditingSending,
            idMessageEditingSending,
            message_show_content: true,
            message_type_content: "success",
            message_title_content: "Editando mensagem",
            message_size_content: "",
            message_slug_target_content: "EDIT_MESSAGE_CONTENT" // slug fixo
        });
    }

    onEditNameContact = async () =>
    {
        let valueEditNameContact = await this.state.nameContactChat;

        await this.setState({
            valueEditNameContact,
            message_show_content: true,
            message_type_content: "success",
            message_title_content: "Editando nome do contato",
            message_size_content: "",
            message_slug_target_content: "EDIT_NAME_CONTACT_CONTENT" // slug fixo
        });
    }

    editNameContact = async () =>
    {
        let valueEditNameContact = await this.state.valueEditNameContact;
        let idServiceDigiSac = await this.state.idServiceDigiSac;
        let indexOpenedChat = await this.state.indexOpenedChat;
        let chats = await this.state.chats;
        let idContact = null;

        // ...getting info by contact...
        for (let i = 0; i < chats.length; i++) 
        {
            if (i === indexOpenedChat)
            {
                let chat = chats[i];
                idContact = chat.idContact;
            }
        }

        valueEditNameContact = valueEditNameContact.toString().trim();
        valueEditNameContact = valueEditNameContact.replace(/[0-9[\]!?~`@#/$%ˆ&*()-+={}:;"'>˜<.,|-]/g, "");

        if (valueEditNameContact === "" || valueEditNameContact.length < 3)
        { 
            await this.message("warning", "Opsssss, o nome deve ter pelo menos 3 letras.");
            return;
        }

        if (idContact === null || idContact === undefined) { return; }

        let result = await whatsappController.changeDataContact(valueEditNameContact, idContact, idServiceDigiSac);

        if (!result.status)
        {
            await this.message("error", "Opsssss, tivemos algum problema ao atualizar o nome do contato. Tente novamente!");
            return;
        }

        await this.setState({valueEditNameContact: ""});
        await this.onCloseModalContent();
    }

    setAsNotRead = async () =>
    {
        let idUserCRM = this.props.user.PER_ID;
        let idCalled = await this.state.idCalledItemList;

        if (!idCalled) { return; }

        await whatsappController.setAsNotRead(idUserCRM, idCalled);

        await this.setState({idCalledItemList: null, activeDropdownItemList: false});
    }

    onDeleteMessage = async () =>
    {
        let obj = await this.state.objectConfirmation;

        if (!this.state.statusConfirmation)
        {
            this.messageConfirmation("warning", "Deseja realmente excluir essa mensagem?");
        }
        else
        {
            let resultDelete = await whatsappController.deleteMessage(obj.id, obj.idDepartament);
    
            if (!resultDelete.status) { this.message("error", resultDelete.data.message); }
    
            await this.setState(
                {
                    statusConfirmation: false,
                    objectConfirmation: {},
                    nameFunctionYesModalConfirmation: "",
                    activeDropdownActionsMessages: false,
                    objMessageTargetByDropdownActions: {...OBJ_MESSAGE_TARGET_BY_DROPDOWN_ACTIONS}
                }
            );
        }
    }

    onCloseCalled = async () =>
    {
        let obj = await this.state.objectConfirmation;

        if (!this.state.statusConfirmation)
        {
            this.messageConfirmation("warning", "Deseja realmente fechar esse chamado?");
        }
        else
        {
            await this.message("information", "Aguarde...Estamos fechando o chamado!");

            let {idCalled} = obj;
            let response = await whatsappController.closeCalled({idCalled});
    
            if (!response.status)
            {
                this.message("error", "Opsssss, tivemos algum problema ao fechar o chamado. Contacte o TI.");
            }

            await this.closeChat();
            await this.setState(
                {
                    statusConfirmation: false,
                    objectConfirmation: {},
                    nameFunctionYesModalConfirmation: ""
                }
            );

            this.customTimeOut(1, async () => {
                await this.closeMessage();
                await this.message("success", "Obaaaaa, chamado fechado com sucesso!");

                this.customTimeOut(1, async () => {
                    await this.closeMessage();
                });
            });
        }
    }

    onSendMessageFromUserWithMultipleDepartaments = async () =>
    {
        let objectConfirmation = await this.state.objectConfirmation;

        if (!this.state.statusConfirmation)
        {
            await this.setState({numberTargetElementToConfirmation: 1});
            await this.messageConfirmation("warning", "Deseja enviar a mensagem? Se sim, através de qual departamento?");
        }
        else
        {
            let choosenDepartament = await this.state.choosenDepartament;

            if (!choosenDepartament)
            {
                await this.messageConfirmation("warning", "Para qual departamento?");
                return;
            }

            if (objectConfirmation.type === "sendFile") { await this.sendFile(); }
            else { await this.sendMessage(); }
        }
    }

    onOpeningCalled = async () =>
    {
        if (!this.state.statusConfirmation)
        {
            await this.setState({numberTargetElementToConfirmation: 1});
            await this.messageConfirmation("warning", "Deseja realmente abrir um chamado? Se sim, para qual departamento e atendente?");
        }
        else
        {
            let cellphoneNumberContact = "";
            let choosenDepartament = await this.state.choosenDepartament;
            let idServiceDigiSac = await this.state.idServiceDigiSac;
            let indexOpenedChat = await this.state.indexOpenedChat;
            let chats = await this.state.chats;
            let chosenUserFromDepartament = await this.state.chosenUserFromDepartament;
            let idUserCRM = chosenUserFromDepartament?.value || null;
            let idDepartament = null;
            let idContact = null;

            if (!choosenDepartament)
            {
                await this.messageConfirmation("warning", "Para qual departamento?");
                return;
            }

            idDepartament = choosenDepartament.value;

            await this.message("information", "Aguarde...Estamos abrindo o chamado!");

            // ...getting info by contact...
            for (let i = 0; i < chats.length; i++) 
            {
                if (i === indexOpenedChat)
                {
                    let chat = chats[i];
                    idContact = chat.idContact;
                    cellphoneNumberContact = chat.cellphoneNumberContact;
                }
            }

            let response = await whatsappController.openCalled(
                cellphoneNumberContact,
                idContact,
                idUserCRM,
                idDepartament,
                idServiceDigiSac
            );

            await this.onClickNoConfirmation();

            this.customTimeOut(1, async () => {
                let status = response.status;
                let message = (status) ? "Obaaaaa, chamado aberto com sucesso!" : "Opsssss, tivemos algum problema ao abrir o chamado. Contacte o TI.";
                await this.closeMessage();
                await this.message((status ? "success" : "error"), message);

                if (status)
                {
                    await this.setState({activeCheckClosedCalledsFilter: false});
                    await this.closeChat();
                }

                this.customTimeOut(3, async () => {
                    await this.closeMessage();
                });
            });
        }
    }

    onTransferCalled = async () =>
    {
        if (!this.state.statusConfirmation)
        {
            await this.setState({numberTargetElementToConfirmation: 2});
            await this.messageConfirmation("warning", "Deseja realmente transferir o chamado? Se sim, para qual departamento e atendente?");
        }
        else
        {
            let cellphoneNumberContact = "";
            let choosenDepartament = await this.state.choosenDepartament;
            let idServiceDigiSac = await this.state.idServiceDigiSac;
            let indexOpenedChat = await this.state.indexOpenedChat;
            let chats = await this.state.chats;
            let chosenUserFromDepartament = await this.state.chosenUserFromDepartament;
            let idCalled = await this.state.idCalled;
            let valueCommentsTransferSending = await this.state.valueCommentsTransferSending;
            let idUserCRM = chosenUserFromDepartament?.value || null;
            let idDepartament = null;
            let idContact = null;

            if (!choosenDepartament)
            {
                await this.messageConfirmation("warning", "Para qual departamento?");
                return;
            }

            idDepartament = choosenDepartament.value;

            await this.message("information", "Aguarde...Estamos transferindo o chamado!");

            // ...getting info by contact...
            for (let i = 0; i < chats.length; i++) 
            {
                if (i === indexOpenedChat)
                {
                    let chat = chats[i];
                    idContact = chat.idContact;
                    cellphoneNumberContact = chat.cellphoneNumberContact;
                }
            }

            let response = await whatsappController.transferCalled(
                {
                    message: valueCommentsTransferSending,
                    cellphoneNumberContact,
                    idCalled,
                    idContact,
                    idUserCRMDestiny: idUserCRM,
                    idDepartamentDestiny: idDepartament,
                    idServiceDigiSac
                }
            );

            await this.onClickNoConfirmation();

            this.customTimeOut(1, async () => {
                let status = (response.code === 200);
                let message = response.data.message;
                await this.closeMessage();
                await this.message((status ? "success" : "error"), message);

                if (status)
                {
                    await this.setState({activeCheckClosedCalledsFilter: false, valueCommentsTransferSending: ""});
                    this.customTimeOut(3, async () => {
                        await this.closeMessage();
                    });
                }
                await this.closeChat();
            });
        }
    }

    onClickYesConfirmation = async () =>
    {
        let fn = this.state.nameFunctionYesModalConfirmation;

        await this.setState({
            statusConfirmation: true,
            message_show_confirmation: false,
            message_confirmation: "",
            message_type_confirmation: "information"
        });

        switch (fn)
        {
            case "onDeleteMessage":
                this.onDeleteMessage();
                break;

            case "onCloseCalled":
                this.onCloseCalled();
                break;

            case "onTransferCalled":
                this.onTransferCalled();
                break;

            case "onOpeningCalled":
                this.onOpeningCalled();
                break;

            case "onSendMessageFromUserWithMultipleDepartaments":
                this.onSendMessageFromUserWithMultipleDepartaments();
                break;
        
            default:
                break;
        }
    }

    onClickNoConfirmation = async () =>
    {
        await this.setState({
            statusConfirmation: false,
            objectConfirmation: {},
            nameFunctionYesModalConfirmation: "",
            numberTargetElementToConfirmation: 0,
            choosenDepartament: null,
            chosenUserFromDepartament: null,
            message_show_confirmation: false,
            message_confirmation: "",
            message_type_confirmation: "information",
        });
    }

    copyCellphoneToClipboard = async (cellphone) =>
    {
        let cellphoneToClipboard = cellphone;

        if (cellphone.toString().length >= 8)
        {
            cellphoneToClipboard = cellphone.substring((cellphone.length -8), cellphone.length);
        }

        await navigator.clipboard.writeText(cellphoneToClipboard);
        await this.setState({activeButtonCopyCellphoneToClipboard: true});
        
        await this.customTimeOut(2, async () => {
            await this.setState({activeButtonCopyCellphoneToClipboard: false});
        });
    }

    searching = async (value) =>
    {
        let searching = this.state.valueSearching.length > 1;
        let showHelpFilterSearching = (value.length >= 1 && value.length <= 3);

        await this.setState({valueSearching: value, searching, showHelpFilterSearching});
        await this.closeChat();
        await this.getAllChatsRealtime();

        setTimeout(() => this.setState({searching: false}), 1000);
    }

    render ()
    {
        return (
            <div className="whatsApp">
                <MessageConfirmation
                    message_type={this.state.message_type_confirmation}
                    message={this.state.message_confirmation}
                    onClose={() => this.onClickNoConfirmation()}
                    show={this.state.message_show_confirmation}
                    onClickYes={() => this.onClickYesConfirmation()}
                    onClickNo={() => this.onClickNoConfirmation()}
                >
                    {
                        (this.state.numberTargetElementToConfirmation === 1 || this.state.numberTargetElementToConfirmation === 2) &&
                        <div className="mt-3">
                            Departamento*
                            <Select
                                classaditional="selectDepartamentsWhatsApp"
                                default={this.state.choosenDepartament}
                                options={this.state.optionsDepartamentsFiltered} 
                                onChange={async (choosenDepartament) => {
                                    await this.setState({choosenDepartament});
                                    await this.getUsersByDepartament(choosenDepartament.value);
                                }}
                            />
                            <br />
                            Atendente
                            <Select
                                withFieldSearch
                                classaditional="selectDepartamentsWhatsApp"
                                default={this.state.chosenUserFromDepartament}
                                options={this.state.optionsUsersFromtDepartaments} 
                                onChange={(chosenUserFromDepartament) => this.setState({chosenUserFromDepartament})}
                            />
                            <br />
                        </div>
                    }
                    {
                        this.state.numberTargetElementToConfirmation === 2 &&
                        <div>
                            Comentário
                            <textarea
                                className="fieldCommentsWhatsApp"
                                placeholder="...comentário" 
                                rows="5"
                                onChange={(e) => this.setState({valueCommentsTransferSending: e.target.value})}
                            />
                            <br />
                        </div>
                    }
                    {
                        (this.state.numberTargetElementToConfirmation === 1 || this.state.numberTargetElementToConfirmation === 2) &&
                        "(*) campos com preenchimento obrigatório."
                    }
                    <div className="mb-4"></div>
                </MessageConfirmation>
                <MessageContent
                    classaditional={`modalContentWhatsApp ${this.state.message_size_content}`}
                    show={this.state.message_show_content}
                    message_type={this.state.message_type_content}
                    message_title={this.state.message_title_content}
                    onClose={() => this.setState({message_show_content: false, message_content_content: null, message_slug_target_content: ""})}
                >
                    {
                        this.state.message_slug_target_content === "EDIT_MESSAGE_CONTENT"
                        &&
                        (
                            <div>
                                <textarea
                                    className="fieldModalCommentsWhatsApp"
                                    placeholder="...mensagem anterior"
                                    rows="5"
                                    value={this.state.valueEditingSending}
                                    onChange={(e) => this.setState({valueEditingSending: e.target.value})}
                                />
                                <br />
                                <div className="lineModalCommentsWhatsApp">
                                    <Button
                                        classaditional="buttonModalCommentsWhatsApp error"
                                        name="cancelar"
                                        onClick={this.onCloseModalContent}
                                    />
                                    <Button
                                        classaditional="buttonModalCommentsWhatsApp success"
                                        name="salvar"
                                        onClick={this.sendEditingMessage}
                                    />
                                </div>
                            </div>
                        )
                    }
                    {
                        this.state.message_slug_target_content === "EDIT_NAME_CONTACT_CONTENT"
                        &&
                        (
                            <div>
                                <InputGeneral
                                    className="fieldModalNameContactWhatsApp"
                                    placeholder="...nome anterior do contato"
                                    value={this.state.valueEditNameContact}
                                    onChange={(e) => this.setState({valueEditNameContact: e.target.value})}
                                />
                                <br />
                                <div className="lineModalCommentsWhatsApp">
                                    <Button
                                        classaditional="buttonModalCommentsWhatsApp error"
                                        name="cancelar"
                                        onClick={this.onCloseModalContent}
                                    />
                                    <Button
                                        classaditional="buttonModalCommentsWhatsApp success"
                                        name="salvar"
                                        onClick={this.editNameContact}
                                    />
                                </div>
                            </div>
                        )
                    }
                    {
                        this.state.message_slug_target_content !== "EDIT_MESSAGE_CONTENT" &&
                        this.state.message_slug_target_content !== "EDIT_NAME_CONTACT_CONTENT" &&
                        this.state.message_content_content
                    }
                </MessageContent>
                {this.state.outputVisible && <div className="developmentWhatsApp">{this.state.outputContent}</div>}
                <div className="errorWhatsApp d-flex d-lg-none">
                    <span>Opsssss, alguns recursos foram desativados para dispositivos móveis.</span>
                </div>
                <div className={`chatListWhatsApp`} style={{width: `${this.state.widthChatList}px`}}>
                    <div className="chatListHeaderWhatsApp">
                        <button 
                            className="buttonDefaultWhatsApp buttonAvatarChatListHeaderWhatsApp"
                            onClick={() => console.log("nothing yet...")}
                        >
                            {
                                this.state.hasAvatar
                                ? <img src={`${process.env.REACT_APP_BACKEND_URL}/user/avatar/${this.props.user.PER_ID}`} alt="Foto do usuário logado" className="avatarChatListHeaderWhatsApp" />
                                : <svg className="avatarDefaultChatListHeaderWhatsApp" viewBox="0 0 212 212" height="212" width="212" preserveAspectRatio="xMidYMid meet" version="1.1" x="0px" y="0px" enableBackground="new 0 0 212 212" xmlSpace="preserve"><path fill="#DFE5E7" className="background" d="M106.251,0.5C164.653,0.5,212,47.846,212,106.25S164.653,212,106.25,212C47.846,212,0.5,164.654,0.5,106.25 S47.846,0.5,106.251,0.5z"></path><g><path fill="#FFFFFF" className="primary" d="M173.561,171.615c-0.601-0.915-1.287-1.907-2.065-2.955c-0.777-1.049-1.645-2.155-2.608-3.299 c-0.964-1.144-2.024-2.326-3.184-3.527c-1.741-1.802-3.71-3.646-5.924-5.47c-2.952-2.431-6.339-4.824-10.204-7.026 c-1.877-1.07-3.873-2.092-5.98-3.055c-0.062-0.028-0.118-0.059-0.18-0.087c-9.792-4.44-22.106-7.529-37.416-7.529 s-27.624,3.089-37.416,7.529c-0.338,0.153-0.653,0.318-0.985,0.474c-1.431,0.674-2.806,1.376-4.128,2.101 c-0.716,0.393-1.417,0.792-2.101,1.197c-3.421,2.027-6.475,4.191-9.15,6.395c-2.213,1.823-4.182,3.668-5.924,5.47 c-1.161,1.201-2.22,2.384-3.184,3.527c-0.964,1.144-1.832,2.25-2.609,3.299c-0.778,1.049-1.464,2.04-2.065,2.955 c-0.557,0.848-1.033,1.622-1.447,2.324c-0.033,0.056-0.073,0.119-0.104,0.174c-0.435,0.744-0.79,1.392-1.07,1.926 c-0.559,1.068-0.818,1.678-0.818,1.678v0.398c18.285,17.927,43.322,28.985,70.945,28.985c27.678,0,52.761-11.103,71.055-29.095 v-0.289c0,0-0.619-1.45-1.992-3.778C174.594,173.238,174.117,172.463,173.561,171.615z"></path><path fill="#FFFFFF" className="primary" d="M106.002,125.5c2.645,0,5.212-0.253,7.68-0.737c1.234-0.242,2.443-0.542,3.624-0.896 c1.772-0.532,3.482-1.188,5.12-1.958c2.184-1.027,4.242-2.258,6.15-3.67c2.863-2.119,5.39-4.646,7.509-7.509 c0.706-0.954,1.367-1.945,1.98-2.971c0.919-1.539,1.729-3.155,2.422-4.84c0.462-1.123,0.872-2.277,1.226-3.458 c0.177-0.591,0.341-1.188,0.49-1.792c0.299-1.208,0.542-2.443,0.725-3.701c0.275-1.887,0.417-3.827,0.417-5.811 c0-1.984-0.142-3.925-0.417-5.811c-0.184-1.258-0.426-2.493-0.725-3.701c-0.15-0.604-0.313-1.202-0.49-1.793 c-0.354-1.181-0.764-2.335-1.226-3.458c-0.693-1.685-1.504-3.301-2.422-4.84c-0.613-1.026-1.274-2.017-1.98-2.971 c-2.119-2.863-4.646-5.39-7.509-7.509c-1.909-1.412-3.966-2.643-6.15-3.67c-1.638-0.77-3.348-1.426-5.12-1.958 c-1.181-0.355-2.39-0.655-3.624-0.896c-2.468-0.484-5.035-0.737-7.68-0.737c-21.162,0-37.345,16.183-37.345,37.345 C68.657,109.317,84.84,125.5,106.002,125.5z"></path></g></svg>
                            }                           
                        </button>
                        <div className="ml-auto anothersButtonsChatListHeaderWhatsApp">
                            <button
                                className="buttonDefaultWhatsApp buttonOthersChatListHeaderWhatsApp ml-auto"
                                onClick={() => console.log("nothing yet...")}
                                title="Comunidades"
                            >
                                <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconOthersChatListHeaderWhatsApp"><path d="m18 11v2h4v-2zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zm4.4-12.01c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zm-16.4 3.4c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3v-12l-5 3zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"></path></svg>
                            </button>
                            <button
                                className="buttonDefaultWhatsApp buttonOthersChatListHeaderWhatsApp"
                                onClick={() => console.log("nothing yet...")}
                                title="Status"
                            >
                                <svg className="iconOthersChatListHeaderWhatsApp" viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M12.072,1.761c-3.941-0.104-7.579,2.105-9.303,5.65c-0.236,0.486-0.034,1.07,0.452,1.305 c0.484,0.235,1.067,0.034,1.304-0.45c1.39-2.857,4.321-4.637,7.496-4.553c0.539,0.02,0.992-0.4,1.013-0.939s-0.4-0.992-0.939-1.013 C12.087,1.762,12.079,1.762,12.072,1.761z M1.926,13.64c0.718,3.876,3.635,6.975,7.461,7.925c0.523,0.13,1.053-0.189,1.183-0.712 c0.13-0.523-0.189-1.053-0.712-1.183c-3.083-0.765-5.434-3.262-6.012-6.386c-0.098-0.53-0.608-0.88-1.138-0.782 C2.178,12.6,1.828,13.11,1.926,13.64z M15.655,21.094c3.642-1.508,6.067-5.006,6.201-8.946c0.022-0.539-0.396-0.994-0.935-1.016 c-0.539-0.022-0.994,0.396-1.016,0.935c0,0.005,0,0.009,0,0.014c-0.107,3.175-2.061,5.994-4.997,7.209 c-0.501,0.201-0.743,0.769-0.543,1.27c0.201,0.501,0.769,0.743,1.27,0.543C15.642,21.1,15.648,21.097,15.655,21.094z"></path><path fill="#009588" d="M19,1.5c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S17.343,1.5,19,1.5z"></path></svg>
                            </button>
                            <button
                                className="buttonDefaultWhatsApp buttonOthersChatListHeaderWhatsApp"
                                onClick={() => console.log("nothing yet...")}
                                title="Nova conversa"
                            >
                                <svg className="iconOthersChatListHeaderWhatsApp" viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path enableBackground="new" d="M19.005,3.175H4.674C3.642,3.175,3,3.789,3,4.821V21.02 l3.544-3.514h12.461c1.033,0,2.064-1.06,2.064-2.093V4.821C21.068,3.789,20.037,3.175,19.005,3.175z M14.016,13.044H7.041V11.1 h6.975V13.044z M17.016,9.044H7.041V7.1h9.975V9.044z"></path></svg>
                            </button>
                            <button
                                className={`buttonDefaultWhatsApp buttonOthersChatListHeaderWhatsApp ${this.state.activeButtonMoreOptions ? "active" : ""}`}
                                onClick={() => this.setState({activeButtonMoreOptions: !this.state.activeButtonMoreOptions, activeDropdownMoreOptions: !this.state.activeDropdownMoreOptions})}
                                title="Mais opções"
                                ref={this.buttonMoreOptions}
                            >
                                <svg className="iconOthersChatListHeaderWhatsApp" viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M12,7c1.104,0,2-0.896,2-2c0-1.105-0.895-2-2-2c-1.104,0-2,0.894-2,2 C10,6.105,10.895,7,12,7z M12,9c-1.104,0-2,0.894-2,2c0,1.104,0.895,2,2,2c1.104,0,2-0.896,2-2C13.999,9.895,13.104,9,12,9z M12,15 c-1.104,0-2,0.894-2,2c0,1.104,0.895,2,2,2c1.104,0,2-0.896,2-2C13.999,15.894,13.104,15,12,15z"></path></svg>
                            </button>
                            <DropdownWhatsApp 
                                classaditional={`dropChatListHeaderWhatsApp`}
                                status={this.state.activeDropdownMoreOptions ? "active" : "inactive"}
                            >
                                <ButtonWhatsApp
                                    onClick={() => console.log("nothing yet...")}
                                    name="Novo grupo"
                                />
                                <ButtonWhatsApp
                                    onClick={() => console.log("nothing yet...")}
                                    name="Nova comunidade"
                                />
                                <ButtonWhatsApp
                                    onClick={() => console.log("nothing yet...")}
                                    name="Mensagens favoritas"
                                />
                                <ButtonWhatsApp
                                    onClick={() => console.log("nothing yet...")}
                                    name="Selecionar conversas"
                                />
                                <ButtonWhatsApp
                                    onClick={() => console.log("nothing yet...")}
                                    name="Configurações"
                                />
                                <ButtonWhatsApp
                                    onClick={() => console.log("nothing yet...")}
                                    name="Desconectar"
                                />
                            </DropdownWhatsApp>
                        </div>
                    </div>
                    <div className="chatListSearchWhatsApp">
                        <span
                            className={`helpFilterSearchingWhatsApp ${this.state.showHelpFilterSearching ? "active" : "inactive"}`}
                            onClick={() => this.setState({showHelpFilterSearching: false})}
                        >
                            Pesquise por nome ou telefone!
                        </span>
                        <button
                            className="buttonDefaultWhatsApp buttonChatListSearchWhatsApp buttonToggleChatListSearchWhatsApp" 
                            onClick={() => this.searching("")}
                        >
                            <i className={`far fa-search iconButtonChatListSearchWhatsApp iconSearchWhatsApp ${!this.state.activeButtonBackChatList ? "active" : "inactive"}`} />
                            <i className={`far fa-arrow-down iconButtonChatListSearchWhatsApp iconLeftWhatsApp ${this.state.activeButtonBackChatList ? "active" : "inactive"}`} />
                        </button>
                        <input
                            className="chatListSearchInputWhatsApp"
                            value={this.state.valueSearching}
                            placeholder="Pesquisar ou começar uma nova conversa"
                            onChange={(e) => this.searching(e.target.value)}
                            onFocus={() => this.setState({activeButtonBackChatList: true})}
                            ref={this.inputSearching}
                        />
                        <button 
                            className={`buttonDefaultWhatsApp buttonChatListSearchWhatsApp buttonClearChatListSearchWhatsApp ${this.state.valueSearching.toString().trim() !== "" ? "active" : "inactive"}`} 
                            onClick={() => this.searching("")}
                        >
                            {
                                !this.state.searching
                                ? <i className="fal fa-times iconButtonChatListSearchWhatsApp iconButtonClearChatListSearchWhatsApp"></i>
                                : <div className="loadingWhatsApp" />
                            }
                        </button>                            
                        <button 
                            className={`buttonDefaultWhatsApp buttonChatListSearchWhatsApp buttonFilterChatListSearchWhatsApp ${this.state.activeButtonFilter ? "active" : ""}`} 
                            onClick={async () => this.filterChats()}
                        >
                            <svg className="iconButtonChatListSearchWhatsApp iconButtonFilterChatListSearchWhatsApp" viewBox="0 0 24 24" height="20" width="20" preserveAspectRatio="xMidYMid meet" version="1.1" x="0px" y="0px" enableBackground="0 0 24 24" xmlSpace="preserve"><path d="M10,18.1h4v-2h-4V18.1z M3,6.1v2h18v-2H3z M6,13.1h12v-2H6V13.1z"/></svg>
                        </button>
                    </div>
                    <div className={`chatListItemsWhatsApp list`} ref={this.chatList}>
                        {
                            !this.state.activeButtonFilter &&
                            <button
                                className="buttonDefaultWhatsApp buttonChatListItemArchivedWhatsApp"
                                onClick={() => console.log("nothing yet...")}
                            >
                                <div className="areaIconChatListItemArchivedWhatsApp">
                                    <svg className="iconChatListItemArchivedWhatsApp" viewBox="0 0 20 20" height="20" width="20" preserveAspectRatio="xMidYMid meet"><path d="M18.54 3.23L17.15 1.55C16.88 1.21 16.47 1 16 1H4C3.53 1 3.12 1.21 2.84 1.55L1.46 3.23C1.17 3.57 1 4.02 1 4.5V17C1 18.1 1.9 19 3 19H17C18.1 19 19 18.1 19 17V4.5C19 4.02 18.83 3.57 18.54 3.23ZM4.24 3H15.76L16.57 3.97H3.44L4.24 3ZM3 17V6H17V17H3ZM11.45 8H8.55V11H6L10 15L14 11H11.45V8Z"></path></svg>
                                </div>
                                <span className="nameChatListItemArchivedWhatsApp">Arquivadas</span>
                            </button>
                        }
                        {  
                            !this.state.activeButtonFilter && this.state.chats.map((c, index) => {
                                let indexOpenedChat = this.state.indexOpenedChat;

                                return (
                                        <ItemListWhatsApp 
                                            key={index}
                                            {...c}
                                            opened={index === indexOpenedChat}
                                            openDropdownItemList={this.openDropdownItemList}
                                            openChat={async () => {
                                                let chats = await this.state.chats;
                                                let lastMessageInternal = c.messages[c.messages.length - 1];
                                                let idLastCalledInternal = lastMessageInternal.idCalled;

                                                await this.setState({idLastCalledOpenedChat: parseInt(idLastCalledInternal)});
                                                await this.openChat(chats, c.idContact, true);
                                            }}
                                        />
                                )
                            }) 
                        }
                        {
                            this.state.activeButtonFilter &&
                            <div className="someFiltersWhatsApp">
                                <Check
                                    classaditional="checkSomeFiltersWhatsApp"
                                    name="meus atendimentos" 
                                    onClick={() => this.setState({activeCheckMyOwnCalledsFilter: !this.state.activeCheckMyOwnCalledsFilter})} 
                                    checked={this.state.activeCheckMyOwnCalledsFilter} 
                                />
                                <Check
                                    classaditional="checkSomeFiltersWhatsApp"
                                    name="chamados fechados" 
                                    onClick={() => this.setState({activeCheckClosedCalledsFilter: !this.state.activeCheckClosedCalledsFilter})} 
                                    checked={this.state.activeCheckClosedCalledsFilter} 
                                />
                            </div>
                        }
                        {/* {
                            this.state.activeButtonFilter && this.state.chatsFiltered.length === 0 &&
                            <div className="nothingChatsFilterWhatsApp">
                                <span className="messageNothingChatsFilterWhatsApp">Nenhuma conversa não lida</span>
                                <button
                                    className="buttonDefaultWhatsApp clearNothingChatsFilterWhatsApp" 
                                    onClick={() => this.filterChats()}
                                >
                                    Limpar filtro
                                </button>
                            </div>
                        } */}
                    </div>
                    {
                        this.state.gettingChats &&
                        <div className="chatListLoadingWhatsApp">
                            <div className="loadingWhatsApp"></div>
                        </div>
                    }
                    <DropdownWhatsApp 
                        classaditional={`dropChatListWhatsApp`}
                        status={this.state.activeDropdownItemList ? `active ${this.state.effectDropdownItemList}` : "inactive"}
                        style={{...this.state.styleDropdownItemList}}
                        classExtendsToDropdown="iconDropItemListWhatsApp"
                        ref={(dropdown) => { this.dropdownItemList = dropdown; }}
                        clickedOutSide={async () => {
                            let activeDropdownItemList = this.state.activeDropdownItemList;
                            if (activeDropdownItemList)
                            { await this.setState({activeDropdownItemList: false}); }
                        }}
                    >
                        <ButtonWhatsApp
                            onClick={() => console.log("nothing yet...")}
                            name="Arquivar conversa"
                        />
                        <ButtonWhatsApp
                            onClick={() => console.log("nothing yet...")}
                            name="Silenciar notificações"
                        />
                        <ButtonWhatsApp
                            onClick={() => console.log("nothing yet...")}
                            name="Apagar conversa"
                        />
                        <ButtonWhatsApp
                            onClick={() => console.log("nothing yet...")}
                            name="Fixar conversa"
                        />
                        <ButtonWhatsApp
                            onClick={() => this.setAsNotRead()}
                            name="Marcar como não lida"
                        />
                    </DropdownWhatsApp>
                </div>
                <div className={`conversationPanelWrapperWhatsApp`} style={{width: `${this.state.widthConversationPanel}px`}}>
                    {
                        this.state.openedChat &&
                        <Fragment>
                            <div className="conversationPanelHeaderWhatsApp">
                                <button 
                                    className="buttonDefaultWhatsApp buttonAvatarConversationHeaderWhatsApp"
                                    onClick={this.openProfile}
                                >
                                    {
                                        this.state.photoContactChat
                                        ? <img src={this.state.photoContactChat} alt="Foto do usuário logado" className="avatarConversationHeaderWhatsApp" />
                                        : <svg className="avatarDefaultConversationHeaderWhatsApp" viewBox="0 0 212 212" height="212" width="212" preserveAspectRatio="xMidYMid meet" version="1.1" x="0px" y="0px" enableBackground="new 0 0 212 212" xmlSpace="preserve"><path fill="#DFE5E7" className="background" d="M106.251,0.5C164.653,0.5,212,47.846,212,106.25S164.653,212,106.25,212C47.846,212,0.5,164.654,0.5,106.25 S47.846,0.5,106.251,0.5z"></path><g><path fill="#FFFFFF" className="primary" d="M173.561,171.615c-0.601-0.915-1.287-1.907-2.065-2.955c-0.777-1.049-1.645-2.155-2.608-3.299 c-0.964-1.144-2.024-2.326-3.184-3.527c-1.741-1.802-3.71-3.646-5.924-5.47c-2.952-2.431-6.339-4.824-10.204-7.026 c-1.877-1.07-3.873-2.092-5.98-3.055c-0.062-0.028-0.118-0.059-0.18-0.087c-9.792-4.44-22.106-7.529-37.416-7.529 s-27.624,3.089-37.416,7.529c-0.338,0.153-0.653,0.318-0.985,0.474c-1.431,0.674-2.806,1.376-4.128,2.101 c-0.716,0.393-1.417,0.792-2.101,1.197c-3.421,2.027-6.475,4.191-9.15,6.395c-2.213,1.823-4.182,3.668-5.924,5.47 c-1.161,1.201-2.22,2.384-3.184,3.527c-0.964,1.144-1.832,2.25-2.609,3.299c-0.778,1.049-1.464,2.04-2.065,2.955 c-0.557,0.848-1.033,1.622-1.447,2.324c-0.033,0.056-0.073,0.119-0.104,0.174c-0.435,0.744-0.79,1.392-1.07,1.926 c-0.559,1.068-0.818,1.678-0.818,1.678v0.398c18.285,17.927,43.322,28.985,70.945,28.985c27.678,0,52.761-11.103,71.055-29.095 v-0.289c0,0-0.619-1.45-1.992-3.778C174.594,173.238,174.117,172.463,173.561,171.615z"></path><path fill="#FFFFFF" className="primary" d="M106.002,125.5c2.645,0,5.212-0.253,7.68-0.737c1.234-0.242,2.443-0.542,3.624-0.896 c1.772-0.532,3.482-1.188,5.12-1.958c2.184-1.027,4.242-2.258,6.15-3.67c2.863-2.119,5.39-4.646,7.509-7.509 c0.706-0.954,1.367-1.945,1.98-2.971c0.919-1.539,1.729-3.155,2.422-4.84c0.462-1.123,0.872-2.277,1.226-3.458 c0.177-0.591,0.341-1.188,0.49-1.792c0.299-1.208,0.542-2.443,0.725-3.701c0.275-1.887,0.417-3.827,0.417-5.811 c0-1.984-0.142-3.925-0.417-5.811c-0.184-1.258-0.426-2.493-0.725-3.701c-0.15-0.604-0.313-1.202-0.49-1.793 c-0.354-1.181-0.764-2.335-1.226-3.458c-0.693-1.685-1.504-3.301-2.422-4.84c-0.613-1.026-1.274-2.017-1.98-2.971 c-2.119-2.863-4.646-5.39-7.509-7.509c-1.909-1.412-3.966-2.643-6.15-3.67c-1.638-0.77-3.348-1.426-5.12-1.958 c-1.181-0.355-2.39-0.655-3.624-0.896c-2.468-0.484-5.035-0.737-7.68-0.737c-21.162,0-37.345,16.183-37.345,37.345 C68.657,109.317,84.84,125.5,106.002,125.5z"></path></g></svg>
                                    }
                                </button>
                                <div className="conversationPanelContactInformationHeaderWhatsApp">
                                    <span className="nameContactHeaderWhatsApp">{this.state.nameContactChat}</span>
                                    <span className={`timeContactHeaderWhatsApp ${this.state.activeTimeContactChat ? "active" : ""}`}>{this.state.timeContactChat}</span>
                                </div> 
                                {
                                    this.state.statusCalled === 1 &&
                                    <button
                                        className="buttonDefaultWhatsApp buttonOthersConversationHeaderWhatsApp ml-auto"
                                        onClick={async () => {
                                            await this.setState(
                                                {
                                                    nameFunctionYesModalConfirmation: "onTransferCalled",
                                                    objectConfirmation: {}
                                                }
                                            );
                                            await this.onTransferCalled();
                                        }}
                                        title="Transferir chamado"
                                    >
                                        <i className="fas fa-exchange-alt iconOthersConversationHeaderWhatsApp"></i>
                                    </button>
                                }
                                {
                                    this.state.statusCalled === 1 &&
                                    <button
                                        className={`buttonDefaultWhatsApp buttonOthersConversationHeaderWhatsApp`}
                                        onClick={async () => {
                                            let idUserCRMFromCalled = await this.state.idUserCRMFromCalled;
                                            let nameUserCRMFromCalled = await this.state.nameUserCRMFromCalled;
                                            let idCalled = await this.state.idCalled;

                                            await this.setState(
                                                {
                                                    nameFunctionYesModalConfirmation: "onCloseCalled",
                                                    objectConfirmation: {
                                                        idUserCRMFromCalled,
                                                        nameUserCRMFromCalled,
                                                        idCalled
                                                    }
                                                }
                                            )
                                            await this.onCloseCalled();
                                        }}
                                        title="Fechar chamado"
                                    >
                                        <i className="far fa-times iconOthersConversationHeaderWhatsApp"></i>
                                    </button>
                                }
                                <button
                                    className={`buttonDefaultWhatsApp buttonOthersConversationHeaderWhatsApp ${(this.state.statusCalled === 2) ? "ml-auto" : ""}`}
                                    onClick={() => console.log("nothing yet...")}
                                    title="Pesquisar..."
                                >
                                    <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconOthersConversationHeaderWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M15.9,14.3H15L14.7,14c1-1.1,1.6-2.7,1.6-4.3c0-3.7-3-6.7-6.7-6.7S3,6,3,9.7 s3,6.7,6.7,6.7c1.6,0,3.2-0.6,4.3-1.6l0.3,0.3v0.8l5.1,5.1l1.5-1.5L15.9,14.3z M9.7,14.3c-2.6,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6 s4.6,2.1,4.6,4.6S12.3,14.3,9.7,14.3z"></path></svg>
                                </button>
                                <button
                                    className="buttonDefaultWhatsApp buttonOthersConversationHeaderWhatsApp"
                                    onClick={this.openProfile}
                                    title="Mais opções"
                                >
                                    <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconOthersConversationHeaderWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M12,7c1.104,0,2-0.896,2-2c0-1.105-0.895-2-2-2c-1.104,0-2,0.894-2,2 C10,6.105,10.895,7,12,7z M12,9c-1.104,0-2,0.894-2,2c0,1.104,0.895,2,2,2c1.104,0,2-0.896,2-2C13.999,9.895,13.104,9,12,9z M12,15 c-1.104,0-2,0.894-2,2c0,1.104,0.895,2,2,2c1.104,0,2-0.896,2-2C13.999,15.894,13.104,15,12,15z"></path></svg>
                                </button>
                            </div>
                            <div
                                className="conversationPanelMessagesWhatsApp"
                                style={{height: `calc(100% - var(--whatsapp-height-chatlist-header) - 22px - ${this.state.minHeightInputSending}px)`}}
                            >
                                <div className="conversationInnerPanelMessagesWhatsApp">
                                </div>
                                <div ref={this.conversationMessagesPanel} onScroll={this.handleScrollConversationMessagesPanel} className="conversationMessagesPanelMessagesWhatsApp">
                                    <button 
                                        className="buttonDefaultWhatsApp buttonLoadOldConversationPanelMessagesWhatsApp" 
                                        onClick={() => this.loadOldMessagesByContactChat()}
                                    >
                                        mensagens anteriores
                                    </button>
                                    {this.state.messagesByChatComponents}
                                </div>
                                <button 
                                    className={`buttonDefaultWhatsApp buttonScrollToBottomConversationPanelMessagesWhatsApp ${this.state.activeButtonScrollToBottom ? "active" : "inactive"}`}
                                    onClick={this.scrollToBottom}
                                >
                                    <svg viewBox="0 0 19 20" height="20" width="19" preserveAspectRatio="xMidYMid meet" className="iconButtonScrollToBottomConversationPanelMessagesWhatsApp" version="1.1" x="0px" y="0px"><path d="M3.8,6.7l5.7,5.7l5.7-5.7l1.6,1.6l-7.3,7.2L2.2,8.3L3.8,6.7z"></path></svg>
                                </button>
                            </div>
                            <div className="conversationPanelSendMessageWhatsApp">
                                {
                                    this.state.statusCalled === 2 &&
                                    <div className="areaToOpenCalledConversationSendMessageWhatsApp">
                                        <Button 
                                            classaditional="buttonToOpenCalledConsersationSendMessageWhatsApp"
                                            name="abrir chamado"
                                            onClick={async () => {
                                                await this.setState(
                                                    {
                                                        nameFunctionYesModalConfirmation: "onOpeningCalled",
                                                        objectConfirmation: {}
                                                    }
                                                );
                                                await this.onOpeningCalled();
                                            }}
                                        />
                                    </div>
                                }
                                <div
                                    ref={this.dropdownOptionsAttachments}
                                    className={`areaMoreOptionsConversationSendMessageWhatsApp ${this.state.activeDropdownMoreActionsAttachments && "active"}`}
                                >
                                    {
                                        !this.state.audioRecord &&
                                        <Fragment>
                                            <button
                                                className="buttonDefaultWhatsApp buttonOthersConversationSendWhatsApp buttonButtonDropdownMoreOptionsAttachmentWhatsApp"
                                                onClick={() => this.getUploadFile()}
                                                title="Arquivo"
                                            >
                                                <div className="buttonInnerButtonDropdownMoreOptionsAttachmentWhatsApp">
                                                    <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconButtonDropdownMoreOptionsAttachmentWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M1.816,15.556v0.002c0,1.502,0.584,2.912,1.646,3.972s2.472,1.647,3.974,1.647 c1.501,0,2.91-0.584,3.972-1.645l9.547-9.548c0.769-0.768,1.147-1.767,1.058-2.817c-0.079-0.968-0.548-1.927-1.319-2.698 c-1.594-1.592-4.068-1.711-5.517-0.262l-7.916,7.915c-0.881,0.881-0.792,2.25,0.214,3.261c0.959,0.958,2.423,1.053,3.263,0.215 c0,0,3.817-3.818,5.511-5.512c0.28-0.28,0.267-0.722,0.053-0.936c-0.08-0.08-0.164-0.164-0.244-0.244 c-0.191-0.191-0.567-0.349-0.957,0.04c-1.699,1.699-5.506,5.506-5.506,5.506c-0.18,0.18-0.635,0.127-0.976-0.214 c-0.098-0.097-0.576-0.613-0.213-0.973l7.915-7.917c0.818-0.817,2.267-0.699,3.23,0.262c0.5,0.501,0.802,1.1,0.849,1.685 c0.051,0.573-0.156,1.111-0.589,1.543l-9.547,9.549c-0.756,0.757-1.761,1.171-2.829,1.171c-1.07,0-2.074-0.417-2.83-1.173 c-0.755-0.755-1.172-1.759-1.172-2.828l0,0c0-1.071,0.415-2.076,1.172-2.83c0,0,5.322-5.324,7.209-7.211 c0.157-0.157,0.264-0.579,0.028-0.814c-0.137-0.137-0.21-0.21-0.342-0.342c-0.2-0.2-0.553-0.263-0.834,0.018 c-1.895,1.895-7.205,7.207-7.205,7.207C2.4,12.645,1.816,14.056,1.816,15.556z"></path></svg>
                                                    <span className="nameButtonDropdownMoreOptionsAttachmentWhatsApp">Arquivo</span>
                                                </div>
                                            </button>
                                            <button
                                                className="buttonDefaultWhatsApp buttonOthersConversationSendWhatsApp buttonButtonDropdownMoreOptionsAttachmentWhatsApp"
                                                onClick={this.setModalToSendComments}
                                                title="Comentário"
                                            >
                                                <div className="buttonInnerButtonDropdownMoreOptionsAttachmentWhatsApp">
                                                    <i className="far fa-comment-dots iconButtonDropdownMoreOptionsAttachmentWhatsApp"></i>
                                                    <span className="nameButtonDropdownMoreOptionsAttachmentWhatsApp">Comentário</span>
                                                </div>
                                            </button>
                                            <button
                                                className="buttonDefaultWhatsApp buttonOthersConversationSendWhatsApp buttonButtonDropdownMoreOptionsAttachmentWhatsApp"
                                                onClick={this.setModalToQuickMessages}
                                                title="Mensagem rápida"
                                            >
                                                <div className="buttonInnerButtonDropdownMoreOptionsAttachmentWhatsApp">
                                                    <i className="far fa-bolt iconButtonDropdownMoreOptionsAttachmentWhatsApp"></i>
                                                    <span className="nameButtonDropdownMoreOptionsAttachmentWhatsApp">Mensagem rápida</span>
                                                </div>
                                            </button>
                                        </Fragment>
                                    }
                                </div>
                                <div
                                    className={`areaAnswerConversationSendMessageWhatsApp ${this.state.activeAnswerMessage ? "active" : "inactive"} `}
                                    style={{bottom: `${this.state.activeAnswerMessage ? `calc(21px + ${this.state.minHeightInputSending}px)` : "-100px"}`}}
                                >
                                    <div className="innerMessageAnswerConversationSendMessageWhatsApp">
                                        <span className="nameAnswerConversationSendMessageWhatsApp">{this.state.answerMessage.name}</span>
                                        <span className="messageAnswerConversationSendMessageWhatsApp">
                                            {this.state.answerMessage.type === AUDIO && <svg viewBox="0 0 12 20" height="20" width="12" preserveAspectRatio="xMidYMid meet" className="iconTypeAnswerConversationSendMessageWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 12 20" xmlSpace="preserve"><path className="iconTypeAnswerConversationSendMessageWhatsApp" d="M6,11.745c1.105,0,2-0.896,2-2V4.941c0-1.105-0.896-2-2-2s-2,0.896-2,2v4.803 C4,10.849,4.895,11.745,6,11.745z M9.495,9.744c0,1.927-1.568,3.495-3.495,3.495s-3.495-1.568-3.495-3.495H1.11 c0,2.458,1.828,4.477,4.192,4.819v2.495h1.395v-2.495c2.364-0.342,4.193-2.362,4.193-4.82H9.495V9.744z"></path></svg>}
                                            {this.state.answerMessage.type === IMAGE && <svg viewBox="0 0 16 20" height="20" width="16" preserveAspectRatio="xMidYMid meet" className="iconTypeAnswerConversationSendMessageWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 16 20" xmlSpace="preserve"><path className="iconTypeAnswerConversationSendMessageWhatsApp" d="M13.822,4.668H7.14l-1.068-1.09C5.922,3.425,5.624,3.3,5.409,3.3H3.531 c-0.214,0-0.51,0.128-0.656,0.285L1.276,5.296C1.13,5.453,1.01,5.756,1.01,5.971v1.06c0,0.001-0.001,0.002-0.001,0.003v6.983 c0,0.646,0.524,1.17,1.17,1.17h11.643c0.646,0,1.17-0.524,1.17-1.17v-8.18C14.992,5.191,14.468,4.668,13.822,4.668z M7.84,13.298 c-1.875,0-3.395-1.52-3.395-3.396c0-1.875,1.52-3.395,3.395-3.395s3.396,1.52,3.396,3.395C11.236,11.778,9.716,13.298,7.84,13.298z  M7.84,7.511c-1.321,0-2.392,1.071-2.392,2.392s1.071,2.392,2.392,2.392s2.392-1.071,2.392-2.392S9.161,7.511,7.84,7.511z"></path></svg>}
                                            {this.state.answerMessage.type === DOCUMENT && <svg viewBox="0 0 13 20" height="20" width="13" preserveAspectRatio="xMidYMid meet" className="iconTypeAnswerConversationSendMessageWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 13 20" xmlSpace="preserve"><path className="iconTypeAnswerConversationSendMessageWhatsApp" d="M10.2,3H2.5C1.7,3,1,3.7,1,4.5v10.1C1,15.3,1.7,16,2.5,16h7.7c0.8,0,1.5-0.7,1.5-1.5v-10 C11.6,3.7,11,3,10.2,3z M7.6,12.7H3.5v-1.3h4.1V12.7z M9.3,10H3.5V8.7h5.8V10z M9.3,7.3H3.5V6h5.8V7.3z"></path></svg>}
                                            {this.state.answerMessage.message}
                                        </span>
                                    </div>
                                    <button
                                        className="buttonDefaultWhatsApp buttonCloseAreaAnswerConversationSendMessageWhatsApp"
                                        onClick={this.closeDropAreaAswerMessage}
                                    >
                                        <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconCloseAreaAnswerConversationSendMessageWhatsApp" fill="currentColor" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M19.6004 17.2L14.3004 11.9L19.6004 6.60005L17.8004 4.80005L12.5004 10.2L7.20039 4.90005L5.40039 6.60005L10.7004 11.9L5.40039 17.2L7.20039 19L12.5004 13.7L17.8004 19L19.6004 17.2Z"></path></svg>
                                    </button>
                                </div>
                                <div className="areaConversationSendWhatsApp">
                                    {
                                        !this.state.audioRecord &&
                                        <button
                                            className="buttonDefaultWhatsApp buttonOthersConversationSendWhatsApp"
                                            onClick={() => this.setState({activeDropdownMoreActionsAttachments: !this.state.activeDropdownMoreActionsAttachments})}
                                            title="Anexar"
                                            ref={this.buttonMoreOptionsAttachments}
                                        >
                                            <svg viewBox="0 0 24 24" width="30" preserveAspectRatio="xMidYMid meet" className={`iconOthersConversationSendWhatsApp iconMoreOptionsAttachamentWhatsApp ${this.state.activeDropdownMoreActionsAttachments && "active"}`}><path d="M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z"></path></svg>
                                        </button>
                                    }
                                    <textarea 
                                        className={`inputConversationSendWhatsApp ${!this.state.audioRecord ? "active" : "inactive"}`}
                                        style={{height: `${this.state.minHeightInputSending}px`}}
                                        placeholder="Mensagem"
                                        value={this.state.valueSending}
                                        cols={40}
                                        onChange={async (e) => {
                                            let value = e.target.value;
                                            let factorHeightInputSending = this.state.factorHeightInputSending;
                                            if (factorHeightInputSending === 1) { value = value.replace(/(\r\n)*\r?\n$/, ""); }
                                            this.setState(
                                                {
                                                    valueSending: value, 
                                                    modeSending: (value.toString().trim() === "") ? AUDIO : TEXT
                                                }
                                            );

                                            if (value.toString().trim() === "") 
                                            { 
                                                await this.setState({valueSending: value.replace(/(\r\n)*\r?\n$/, "")}); //forcing remove all break rows on textarea component
                                            }
                                        }}
                                        ref={(input) => this.inputSending = input}
                                        onKeyUp={async (e) => {
                                            let isShiftLeft = e.code === "ShiftLeft";
                                            if (isShiftLeft) { await this.setState({inputSendigShiftLeftPressed: false}); }
                                        }}
                                        onKeyDown={async (e) => {
                                            let isShiftLeft = e.code === "ShiftLeft";
                                            if (isShiftLeft) { await this.setState({inputSendigShiftLeftPressed: true}); }
                                            let inputSendigShiftLeftPressed = await this.state.inputSendigShiftLeftPressed;
                                            if (e.code === "Enter" && !inputSendigShiftLeftPressed) { this.sendMessage(); }
                                            if (inputSendigShiftLeftPressed && e.code === "Enter") { this.setMultipleLineTextArea(); }
                                        }}
                                    />
                                    {
                                        this.state.audioRecord &&
                                        <button
                                            className="buttonDefaultWhatsApp buttonOthersConversationSendWhatsApp"
                                            onClick={async () => {
                                                await this.deleteRecordingAudio();
                                            }}
                                            title="Apagar"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 22" className="iconOthersConversationSendWhatsApp delete"><path d="M5,0,3,2H0V4H16V2H13L11,0ZM15,5H1V19.5A2.5,2.5,0,0,0,3.5,22h9A2.5,2.5,0,0,0,15,19.5Z"></path></svg>
                                        </button>
                                    }
                                    <AudioRecordingWhatsApp
                                        classaditional={`audioRecordingConversationSendWhatsApp ${this.state.audioRecord ? "active" : "inactive"}`}
                                        recording={this.state.recording}
                                        clearRecording={this.state.clearRecording}
                                        onChangeClearRecording={(clearRecording) => this.setState({clearRecording})}
                                        onPauseRecording={async (pathAudio, blobAudio) => { await this.setState({pathAudio, blobAudio}) }}
                                    />
                                    {
                                        (!this.state.audioRecord && this.state.valueSending.toString().trim() === "")&&
                                        <button
                                            className={`
                                                buttonDefaultWhatsApp 
                                                buttonOthersConversationWithoutEffectSendWhatsApp
                                                active
                                            `}
                                            onClick={() => this.startRecordingAudio()}
                                        >
                                            <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className={`iconOthersConversationSendWhatsApp`} version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M11.999,14.942c2.001,0,3.531-1.53,3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531 S8.469,2.35,8.469,4.35v7.061C8.469,13.412,9.999,14.942,11.999,14.942z M18.237,11.412c0,3.531-2.942,6.002-6.237,6.002 s-6.237-2.471-6.237-6.002H3.761c0,4.001,3.178,7.297,7.061,7.885v3.884h2.354v-3.884c3.884-0.588,7.061-3.884,7.061-7.885 L18.237,11.412z"></path></svg>
                                        </button>
                                    }
                                    {
                                        this.state.recording &&
                                        <button
                                            className={`
                                                buttonDefaultWhatsApp 
                                                buttonOthersConversationWithoutEffectSendWhatsApp
                                                active
                                            `}
                                            onClick={() => this.pauseRecordingAudio()}
                                        >
                                            <i className="fas fa-stop iconOthersConversationSendWhatsApp activeRecording"></i>
                                        </button>
                                    }
                                    {
                                        (this.state.modeSending === TEXT || (this.state.audioRecord && !this.state.recording)) &&
                                        <button
                                            className="buttonDefaultWhatsApp buttonOthersConversationSendWhatsApp"
                                            onClick={this.sendMessage}
                                        >
                                            <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconOthersConversationSendWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M1.101,21.757L23.8,12.028L1.101,2.3l0.011,7.912l13.623,1.816L1.112,13.845 L1.101,21.757z"></path></svg>
                                        </button>
                                    }
                                </div>
                            </div>
                            {
                                this.state.uploadModeChat &&
                                <div
                                    className="conversationPanelUplodaWhatsApp"
                                    style={{width: `calc(100% - ${this.state.widthChatList}px)`}}
                                >
                                    <div className="conversationPanelUplodaHeaderWhatsApp">
                                        <button 
                                            className="buttonDefaultWhatsApp buttonCloseConversationPanelUplodaHeaderWhatsApp" 
                                            onClick={this.closeUploadFile}
                                        >
                                            <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconButtonCloseConversationPanelUplodaHeaderWhatsApp" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path d="M19.6004 17.2L14.3004 11.9L19.6004 6.60005L17.8004 4.80005L12.5004 10.2L7.20039 4.90005L5.40039 6.60005L10.7004 11.9L5.40039 17.2L7.20039 19L12.5004 13.7L17.8004 19L19.6004 17.2Z"></path></svg>
                                        </button>
                                        <span className="noSelectionWhatsApp nameConversationPanelUplodaHeaderWhatsApp">{this.state.nameFileUploadChat === "" ? "" : this.state.nameFileUploadChat}</span>
                                    </div>
                                    <div className="conversationPanelUplodaBodyWhatsApp">
                                        {this.getPreviewFromUploadFile()}
                                        {this.state.extensionFileUploadChat !== PNG && this.state.extensionFileUploadChat !== JPG && <h6 className="noSelectionWhatsApp titleConversationPanelUploadBodyWhatsApp">Pré-visualização indisponível</h6>}
                                        {
                                            this.state.extensionFileUploadChat !== PNG && 
                                            this.state.extensionFileUploadChat !== JPG &&
                                            <div className="noSelectionWhatsApp detailsConversationPanelUploadBodyWhatsApp">
                                                <span>{this.state.sizeFileUploadChat === "" ? "0 KB" : this.state.sizeFileUploadChat}</span>
                                                <span>{this.state.extensionFileUploadChat === "" ? "" : " - "+this.state.extensionFileUploadChat}</span>
                                            </div>
                                        }
                                        <div className="areaInputMessageConversationPanelUploadBodyWhatsApp">
                                            <input 
                                                type="text" 
                                                className="inputMessageConversationPanelUploadBodyWhatsApp" 
                                                placeholder="Mensagem"
                                                value={this.state.messageFileUploadChat}
                                                onChange={(e) => this.setState({messageFileUploadChat: e.target.value})}
                                            />
                                            {
                                                this.state.messageFileUploadChat !== "" &&
                                                <button 
                                                    className="buttonDefaultWhatsApp buttonClearConversationPanelUploadBodyWhatsApp"
                                                    onClick={() => this.setState({messageFileUploadChat: ""})}
                                                >
                                                    <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconButtonClearConversationPanelUploadBodyWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path className="iconButtonClearConversationPanelUploadBodyWhatsApp" d="M17.25,7.8L16.2,6.75l-4.2,4.2l-4.2-4.2L6.75,7.8l4.2,4.2l-4.2,4.2l1.05,1.05l4.2-4.2l4.2,4.2l1.05-1.05 l-4.2-4.2L17.25,7.8z"></path></svg>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                    <div className="conversationPanelUplodaFooterWhatsApp">
                                        <button 
                                            className="buttonDefaultWhatsApp buttonSendMessageConversationPanelUploadFooterWhatsApp"
                                            onClick={() => this.sendFile()}
                                        >
                                            <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconButtonSendMessageConversationPanelUploadFooterWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24" xmlSpace="preserve"><path fill="iconButtonSendMessageConversationPanelUploadFooterWhatsApp" d="M1.101,21.757L23.8,12.028L1.101,2.3l0.011,7.912l13.623,1.816L1.112,13.845 L1.101,21.757z"></path></svg>
                                        </button>
                                    </div>
                                </div>
                            }
                        </Fragment>
                    }
                    { !this.state.openedChat && <NoOpenedChatWhatsApp /> }
                    <DropdownWhatsApp 
                        classaditional={`dropConversationActionsWhatsApp ${this.state.effectDropdownActionsMessage}`}
                        status={this.state.activeDropdownActionsMessages ? `active` : "inactive"}
                        style={{...this.state.styleDropdownActionsMessages}}
                        classExtendsToDropdown="iconButtonDropMoreActionsMessageWhatsApp"
                        ref={(dropdown) => { this.dropdownActionsMessages = dropdown; }}
                        clickedOutSide={async () => {
                            let activeDropdownActionsMessages = this.state.activeDropdownActionsMessages;
                            if (activeDropdownActionsMessages)
                            { await this.setState({activeDropdownActionsMessages: false}); }
                        }}
                    >
                        <ButtonWhatsApp
                            onClick={() => console.log("nothing yet...")}
                            name="Dados da mensagem"
                        />
                        <ButtonWhatsApp
                            onClick={this.replyToMessage}
                            name="Responder"
                        />
                        <ButtonWhatsApp
                            onClick={() => console.log("nothing yet...")}
                            name="Reagir"
                        />
                        <ButtonWhatsApp
                            onClick={() => console.log("nothing yet...")}
                            name="Encaminhar"
                        />
                        <ButtonWhatsApp
                            onClick={() => console.log("nothing yet...")}
                            name="Favoritar"
                        />
                        {
                            this.state.showOptionsEditingDropdownActionsMessage &&
                            <ButtonWhatsApp
                                onClick={() => this.onEditMessage()}
                                name="Editar"
                            />
                        }
                        {
                            this.state.showOptionDeleteDropdownActionsMessage &&
                            <ButtonWhatsApp
                                onClick={async () => {
                                    let objMessage = await this.state.objMessageTargetByDropdownActions;
                                    let idDepartament = await this.state.idDepartament;

                                    await this.setState({
                                        objectConfirmation: {...objMessage, idDepartament},
                                        nameFunctionYesModalConfirmation: "onDeleteMessage"
                                    });
                                    this.onDeleteMessage();
                                }}
                                name="Apagar"
                            />
                        }
                    </DropdownWhatsApp>
                    <input type="file" ref={this.inputFile} onChange={this.onChangeUploadFile} hidden/>
                </div>
                <div
                    className={`conversationPanelMoreDetailsProfileWhatsApp`}
                    style={{width: `${this.state.widthMoreDetailsProfile}px`}}
                >
                    <div className="moreDetailsProfileGeneralWhatsApp">
                        <div className="headerMoreDetailsProfileGeneralWhatsApp">
                            <button
                                className="buttonDefaultWhatsApp buttonCloseMoreDetailsProfileGeneralWhatsApp"
                                onClick={this.closeProfile}
                            >
                                <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconButtonCloseMoreDetailsProfileGeneralWhatsApp" enableBackground="new 0 0 24 24"><path d="M19.6004 17.2L14.3004 11.9L19.6004 6.60005L17.8004 4.80005L12.5004 10.2L7.20039 4.90005L5.40039 6.60005L10.7004 11.9L5.40039 17.2L7.20039 19L12.5004 13.7L17.8004 19L19.6004 17.2Z"></path></svg>
                            </button>
                            <span className="aboutMoreDetailsProfileGeneralWhatsApp">Dados do contato</span>
                        </div>
                        <div className={`bodyMoreDetailsProfileGeneralWhatsApp ${this.state.widthMoreDetailsProfile > 0 ? "active" : "inactive"}`}>
                            <div className="boxMoreDetailsProfileGeneralWhatsApp avatar">
                                <ButtonIcon
                                    classaditional={`buttonIconEditContactMoreDetailsProfileGeneralWhatsApp`}
                                    icon="fas fa-pencil"
                                    onClick={this.onEditNameContact}
                                />
                                <button
                                    className={`buttonDefaultWhatsApp buttonAvatarMoreDetailsProfileGeneralWhatsApp ${this.state.widthMoreDetailsProfile > 0 ? "active" : "inactive"}`}
                                    onClick={() => console.log("nothing yet...")}
                                >
                                    {
                                        this.state.photoContactChat 
                                        ?
                                        <img src={this.state.photoContactChat} alt="Foto do usuário do contato" className="avatarMoreDetailsProfileGeneralWhatsApp" />
                                        :
                                        <svg className="avatarMoreDetailsProfileGeneralWhatsApp" viewBox="0 0 212 212" height="212" width="212" preserveAspectRatio="xMidYMid meet" version="1.1" x="0px" y="0px" enableBackground="new 0 0 212 212" xmlSpace="preserve"><path fill="#DFE5E7" className="background" d="M106.251,0.5C164.653,0.5,212,47.846,212,106.25S164.653,212,106.25,212C47.846,212,0.5,164.654,0.5,106.25 S47.846,0.5,106.251,0.5z"></path><g><path fill="#FFFFFF" className="primary" d="M173.561,171.615c-0.601-0.915-1.287-1.907-2.065-2.955c-0.777-1.049-1.645-2.155-2.608-3.299 c-0.964-1.144-2.024-2.326-3.184-3.527c-1.741-1.802-3.71-3.646-5.924-5.47c-2.952-2.431-6.339-4.824-10.204-7.026 c-1.877-1.07-3.873-2.092-5.98-3.055c-0.062-0.028-0.118-0.059-0.18-0.087c-9.792-4.44-22.106-7.529-37.416-7.529 s-27.624,3.089-37.416,7.529c-0.338,0.153-0.653,0.318-0.985,0.474c-1.431,0.674-2.806,1.376-4.128,2.101 c-0.716,0.393-1.417,0.792-2.101,1.197c-3.421,2.027-6.475,4.191-9.15,6.395c-2.213,1.823-4.182,3.668-5.924,5.47 c-1.161,1.201-2.22,2.384-3.184,3.527c-0.964,1.144-1.832,2.25-2.609,3.299c-0.778,1.049-1.464,2.04-2.065,2.955 c-0.557,0.848-1.033,1.622-1.447,2.324c-0.033,0.056-0.073,0.119-0.104,0.174c-0.435,0.744-0.79,1.392-1.07,1.926 c-0.559,1.068-0.818,1.678-0.818,1.678v0.398c18.285,17.927,43.322,28.985,70.945,28.985c27.678,0,52.761-11.103,71.055-29.095 v-0.289c0,0-0.619-1.45-1.992-3.778C174.594,173.238,174.117,172.463,173.561,171.615z"></path><path fill="#FFFFFF" className="primary" d="M106.002,125.5c2.645,0,5.212-0.253,7.68-0.737c1.234-0.242,2.443-0.542,3.624-0.896 c1.772-0.532,3.482-1.188,5.12-1.958c2.184-1.027,4.242-2.258,6.15-3.67c2.863-2.119,5.39-4.646,7.509-7.509 c0.706-0.954,1.367-1.945,1.98-2.971c0.919-1.539,1.729-3.155,2.422-4.84c0.462-1.123,0.872-2.277,1.226-3.458 c0.177-0.591,0.341-1.188,0.49-1.792c0.299-1.208,0.542-2.443,0.725-3.701c0.275-1.887,0.417-3.827,0.417-5.811 c0-1.984-0.142-3.925-0.417-5.811c-0.184-1.258-0.426-2.493-0.725-3.701c-0.15-0.604-0.313-1.202-0.49-1.793 c-0.354-1.181-0.764-2.335-1.226-3.458c-0.693-1.685-1.504-3.301-2.422-4.84c-0.613-1.026-1.274-2.017-1.98-2.971 c-2.119-2.863-4.646-5.39-7.509-7.509c-1.909-1.412-3.966-2.643-6.15-3.67c-1.638-0.77-3.348-1.426-5.12-1.958 c-1.181-0.355-2.39-0.655-3.624-0.896c-2.468-0.484-5.035-0.737-7.68-0.737c-21.162,0-37.345,16.183-37.345,37.345 C68.657,109.317,84.84,125.5,106.002,125.5z"></path></g></svg>
                                    }
                                </button>
                                <span className="nameMoreDetailsProfileGeneralWhatsApp">{this.state.nameContactChat}</span>
                                <span className="cellphoneMoreDetailsProfileGeneralWhatsApp">
                                    {this.state.cellphoneContactChat && fomartedCellphone(this.state.cellphoneContactChat)}
                                    <ButtonIcon
                                        classaditional={`buttonIconMoreDetailsProfileGeneralWhatsApp ${this.state.activeButtonCopyCellphoneToClipboard && "active"}`}
                                        icon="fas fa-clipboard"
                                        onClick={() => this.copyCellphoneToClipboard(this.state.cellphoneContactChat)}
                                    />
                                    <span className={`help ${this.state.activeButtonCopyCellphoneToClipboard && "active"}`}>copiado</span>
                                </span>
                            </div>
                            <div className="boxMoreDetailsProfileGeneralWhatsApp">
                                <span className="infosCalledWhatsApp title">Informações do Chamado</span>
                                <span className="infosCalledWhatsApp subtitle"><i className="fas fa-hashtag iconInfosCalledWhatsApp"></i>{this.state.infosCalled.idCalled}</span>
                                <span className="infosCalledWhatsApp subtitle"><i className="fas fa-user iconInfosCalledWhatsApp"></i>{this.state.infosCalled.nameAttendantCalled}</span>
                                <span className="infosCalledWhatsApp subtitle"><i className="fas fa-project-diagram iconInfosCalledWhatsApp"></i>{this.state.infosCalled.nameDepartamentCalled}</span>
                                <span className="infosCalledWhatsApp subtitle"><i className="fas fa-building iconInfosCalledWhatsApp"></i>{this.state.infosCalled.nameCompanyUnitCalled}</span>
                                <span className="infosCalledWhatsApp subtitle"><i className="fab fa-whatsapp iconInfosCalledWhatsApp"></i>{this.state.nameConnection}</span>
                            </div>
                            <div className="boxMoreDetailsProfileGeneralWhatsApp">
                                <ButtonDetailsAndSelectPanelWhatsApp
                                    classaditional="buttonFilesWhatsApp"
                                    title="Arquivos de mídia, links e docs"
                                    amount="0"
                                    onClick={() => this.setState({activeMoreDetailsProfileFile: true})}
                                />
                            </div>
                            <div className="boxMoreDetailsProfileGeneralWhatsApp">
                                <ButtonDetailsAndSelectPanelWhatsApp
                                    icon={<svg viewBox="0 0 16 15" height="20" preserveAspectRatio="xMidYMid meet" version="1.1" x="0px" y="0px" enableBackground="new 0 0 16 15"><path d="M8.3,10.2l-2.5,1.7c-0.3,0.2-0.8-0.1-0.7-0.5L6,8.6c0.1-0.2,0-0.4-0.2-0.5L3.5,6.3C3.1,6,3.3,5.5,3.7,5.5 l3-0.1c0.2,0,0.3-0.1,0.4-0.3l1-2.8c0.1-0.4,0.7-0.4,0.8,0l1,2.8c0.1,0.2,0.2,0.3,0.4,0.3l3,0.1c0.4,0,0.6,0.5,0.3,0.8l-2.4,1.8 C11.1,8.2,11,8.4,11,8.6l0.9,2.9c0.1,0.4-0.3,0.7-0.7,0.5l-2.5-1.7C8.6,10.1,8.4,10.1,8.3,10.2z"></path></svg>}
                                    title="Mensagens Favoritas"
                                    onClick={() => this.setState({activeMoreDetailsProfileFile: true})}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`moreDetailsProfileFilesWhatsApp ${this.state.activeMoreDetailsProfileFile ? "active" : "inactive"}`}>
                        <div className="headerMoreDetailsProfileFilesWhatsApp">
                            <button
                                className="buttonDefaultWhatsApp buttonCloseMoreDetailsProfileFilesWhatsApp"
                                onClick={() => this.setState({activeMoreDetailsProfileFile: false})}
                            >
                                <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" className="iconButtonCloseMoreDetailsProfileFilesWhatsApp" version="1.1" x="0px" y="0px" enableBackground="new 0 0 24 24"><path d="M12,4l1.4,1.4L7.8,11H20v2H7.8l5.6,5.6L12,20l-8-8L12,4z"></path></svg>
                            </button>
                        </div>
                        <div className="bodyMoreDetailsProfileProfileWhatsApp">
                            <span>nothing yet</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps (state)
{
    const {hasPermissionsLoaded, whatsapp} = state.permissions;
    const {general} = state;
    const {user} = state.auth;
    
    return {
        user,
        general,
        whatsapp,
        hasPermissionsLoaded
    }
}

function mapDispatchToProps (dispatch)
{
    return {
        setModalMessage (data)
        {
            //action creator -> action
            const action = setModalMessage(data);
            dispatch(action);
        },
        setListenerWhatsAppUpdatedMessages (status)
        {
            //action creator -> action
            const action = setListenerWhatsAppUpdatedMessages(status);
            dispatch(action);
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WhatsApp));